// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-01T17:22:15.292Z
// Property: Villas at Old 441 (ID: 6767906449167445)
// Collections: 13 amenities, 3 floorplans (live), 22 photos, 37 POIs, 8 reviews, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162258",
  "multihub_property_id": "6767906449167445",
  "property_external_id": "100160113",
  "property_zillow_url": "https://www.zillow.com/apartments/demorest-ga/villas-at-old-441/CjwMcq/",
  "property_apartments_url": "https://www.apartments.com/villas-at-old-441-demorest-ga/gqn6v5x/",
  "property_google_business_url": "https://www.google.com/maps/place/Villas+at+Old+441/data=!4m2!3m1!1s0x0:0xe75e5a874500748c?sa=X&ved=1t:2428&ictx=111",
  "property_linkedin_url": null,
  "property_hubspot_id": "56632107690",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": "5605581",
  "property_status": null,
  "property_slug": "villas-at-old-441",
  "property_name": "Villas at Old 441",
  "property_website_url": "https://www.liveatvillasatold441.com/",
  "property_domain": "https://www.liveatvillasatold441.com/",
  "property_address": "101 Oakey Alley",
  "property_full_address": "101 Oakey Alley, Demorest, GA 30535",
  "property_address_1": "101 Oakey Alley",
  "property_address_2": null,
  "property_address_city": "Demorest",
  "property_address_state": "GA",
  "property_address_zip_full": null,
  "property_address_zip": "30535",
  "property_address_country": "US",
  "property_address_county": "Habersham County",
  "property_neighborhood_address": "Georgia Northeast",
  "property_address_latitude": "34.5844945",
  "property_address_longitude": "-83.5355278",
  "property_email": null,
  "property_phone": "(706) 903-9711",
  "property_call_tracking_phone": "7622384731",
  "property_company_name": "Axia Residential (ARC Living)",
  "property_company_url": "https://www.axiares.com/",
  "agency_contacts": null,
  "property_type": "Apartment",
  "property_short_description": "At Villas at Old 441 in Demorest, GA, your perfect home awaits! Choose from spacious one, two, or three-bedroom floor plans featuring chef-inspired kitchens and designer finishes. Unwind by our sparkling pool, enjoy the beer garden, or get active at our fitness center. Embrace a lifestyle of comfort and convenience today!",
  "property_long_description": "Welcome to Villas at Old 441, your ideal apartment community nestled in the picturesque surroundings of Demorest, GA. Offering an array of spacious floor plans, our one, two, and three-bedroom apartments are designed to cater to your lifestyle needs, providing comfort and elegance in every corner. \n\nAt Villas at Old 441, you’ll enjoy a premium living experience with modern amenities that elevate your everyday routine. Dive into relaxation at our sparkling swimming pool, unwind in the inviting beer garden, or let your little ones explore the playground while your furry friends romp around in our bark park. Staying active is easy in our fully-equipped fitness center, and our stylish clubhouse is the perfect spot for socializing with neighbors.\n\nEach apartment features chef-inspired kitchens adorned with stainless steel appliances and stunning granite countertops. You’ll love the inviting ambiance created by wood-style flooring and designer finishes throughout your new home. Plus, with washer and dryer units included, daily chores become a breeze.\n\nFinding your new home at the Villas at Old 441 means embracing a lifestyle of convenience, comfort, and community. Don’t miss your chance to discover the perfect blend of amenities and stylish living in Demorest, GA. Ready to experience it for yourself? Browse our availability or schedule a personalized tour today, and make Villas at Old 441 your new home sweet home!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-7b25-733c-98d5-10a57b7481ed.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior of a modern apartment building at dusk with warm lights illuminating the windows.",
    "public_id": "019d72d2-7b25-733c-98d5-10a57b7481ed",
    "storage_key": "property/6767906449167445/019d72d2-7b25-733c-98d5-10a57b7481ed.webp",
    "width": 1800,
    "height": 700
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "141",
  "property_year_built": "2023",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "99.29078014184397",
  "property_admin_fee": null,
  "property_application_fee": "50",
  "property_fees_deposit_info": "Security deposit: $500.00 (refundable).",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "20",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Cats and dogs allowed. Maximum 2 pets per unit.",
  "property_pet_policy_description": "The Villas at Old 441 is a pet-friendly community!",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://villasatold411axia.prospectportal.com/Demorest/Villas at Old 441",
  "property_resident_portal_url": "https://villasatold411axia.residentportal.com/auth",
  "property_apply_now_url": "https://villasatold411axia.prospectportal.com/Apartments/module/application_authentication/popup/false/kill_session/1/property/100160113/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019db621-abad-70b9-a8ac-67b9f507a71c.webp",
  "property_primary_logo_media": {
    "alt_text": "Villas at Old 441 logo",
    "public_id": "019db621-abad-70b9-a8ac-67b9f507a71c",
    "storage_key": "property/6767906449167445/019db621-abad-70b9-a8ac-67b9f507a71c.webp",
    "width": 1378,
    "height": 527
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d7464-4a89-754c-ab3b-b29918844920.webp",
  "property_secondary_logo_media": {
    "alt_text": "Villas at Old 441 logo",
    "public_id": "019d7464-4a89-754c-ab3b-b29918844920",
    "storage_key": "property/6767906449167445/019d7464-4a89-754c-ab3b-b29918844920.webp",
    "width": 1250,
    "height": 1250
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019df453-5388-7288-83df-6be3b7526f17.webp",
  "property_fav_icon_media": {
    "alt_text": "Vector V logo",
    "public_id": "019df453-5388-7288-83df-6be3b7526f17",
    "storage_key": "property/6767906449167445/019df453-5388-7288-83df-6be3b7526f17.webp",
    "width": 33,
    "height": 33
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d7984-6320-72c7-a436-b3500fcca958.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019d7984-6320-72c7-a436-b3500fcca958",
    "storage_key": "property/6767906449167445/019d7984-6320-72c7-a436-b3500fcca958.webp",
    "width": 535,
    "height": 321
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d7984-5827-71d8-90e0-b53cf68a8cfb.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019d7984-5827-71d8-90e0-b53cf68a8cfb",
    "storage_key": "property/6767906449167445/019d7984-5827-71d8-90e0-b53cf68a8cfb.webp",
    "width": 535,
    "height": 321
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019d54d9-0a7f-7644-86f7-60a98c66fa2f.webp",
  "property_company_logo_media": {
    "alt_text": "AXIA RESIDENTIAL BY ARC logo",
    "public_id": "019d54d9-0a7f-7644-86f7-60a98c66fa2f",
    "storage_key": "company/5767906449162258/019d54d9-0a7f-7644-86f7-60a98c66fa2f.webp",
    "width": 3072,
    "height": 1849
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019d54d9-c530-7559-a71a-a1a4613d29fc.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "AXIA Residential by ARC logo",
    "public_id": "019d54d9-c530-7559-a71a-a1a4613d29fc",
    "storage_key": "company/5767906449162258/019d54d9-c530-7559-a71a-a1a4613d29fc.webp",
    "width": 125,
    "height": 75
  },
  "property_primary_color": "#242424",
  "property_secondary_color": "#373737",
  "property_font_color": "#464646",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "650 - 1159",
  "property_sqft_min": "650",
  "property_sqft_max": "1159",
  "property_price_range": "$1423 - $1687",
  "property_price_min": "1423",
  "property_price_max": "1687",
  "property_available_units": 1,
  "property_facebook_url": "https://www.facebook.com/villasatold411",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJN5oeBK2zWIgRjHQARYdaXuc",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Villas at Old 441",
  "property_home_romance_title": "Embrace Comfort and Connection in Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to Villas at Old 441 in picturesque Demorest, GA! Experience spacious floor plans, from one to three bedrooms, designed with chef-inspired kitchens and modern finishes. Relax at our sparkling pool, enjoy the beer garden, or unwind at the bark park. Your perfect home and vibrant community await!",
  "property_home_floorplans_blurb": "Welcome to Villas at Old 441 in Demorest, GA, where modern living meets comfort. Choose from our thoughtfully designed one, two, and three-bedroom apartments tailored to enhance your lifestyle. Browse our available homes today and uncover the ideal space that meets your needs and desires!",
  "property_home_gallery_blurb": "At Villas at Old 441 in Demorest, GA, your new home blends comfort and style. Enjoy a morning dip in our sparkling pool, unwind in the beer garden, or cook up a feast in your chef-inspired kitchen, complete with granite counters and stainless steel appliances. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Welcome to Villas at Old 441 in Demorest, GA, where spacious one, two, and three-bedroom apartments meet a vibrant neighborhood. Uncover nearby treasures like Piedmont University, the captivating Miles Through Time Automotive Museum, and scenic parks like Cornelia City Park. Embrace life surrounded by culture and adventure!",
  "property_home_reviews_blurb": "At Villas at Old 441 in Demorest, GA, residents rave about the welcoming atmosphere and vibrant community. One happy tenant shares, “It feels like home here!” Experience unparalleled comfort and convenience—check out our resident testimonials to see how life flourishes at Villas at Old 441! ",
  "property_neighborhood_blurb": "At Villas at Old 441 in Demorest, GA, life is vibrant beyond your doorstep. Surround yourself with local gems like the historic 441 Antique Mall, the scenic Chenocetah Lookout Tower, and the engaging Miles Through Time Automotive Museum. Uncover nature’s beauty at nearby parks, enhancing your everyday living experience.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Villas at Old 441 in Demorest, GA, where every day feels like a retreat. Choose from stylish one, two, or three-bedroom floor plans, each featuring chef-inspired kitchens and upscale designer finishes. Dive into our sparkling pool, unwind in the beer garden, or enjoy time at our bark park. ",
  "property_applynow_blurb": "Unwind at Villas at Old 441 in Demorest, GA, where modern living meets leisure. Choose from spacious one, two, or three-bedroom floor plans featuring chef-inspired kitchens, designer finishes, and luxurious amenities like a sparkling swimming pool and bark park. Your perfect home awaits—lease online today!",
  "property_contactus_blurb": "At Villas at Old 441 in Demorest, GA, our thoughtfully designed one, two, and three-bedroom floor plans cater to your lifestyle. Each apartment combines comfort and style, creating a welcoming retreat. Curious to learn more? Have questions? Contact our leasing team today! Your new home awaits!",
  "property_faqs_blurb": "At Villas at Old 441 in Demorest, GA, we offer a range of thoughtfully designed floor plans—one, two, and three-bedroom options that fit your lifestyle. Have questions? Our FAQs page is here to provide the answers you need to make the Villas your new home!",
  "property_floorplans_blurb": "At Villas at Old 441 in Demorest, GA, a perfect blend of comfort and style awaits. Choose from our thoughtfully designed one, two, or three-bedroom floor plans, each thoughtfully crafted to enhance your living experience. Browse our available apartment homes and transform your vision of home into reality.",
  "property_gallery_blurb": "At Villas at Old 441 in Demorest, GA, vibrant living awaits! Imagine lounging by the sparkling swimming pool or hosting friends in your chef-inspired kitchen with stainless steel appliances. With spacious one, two, and three-bedroom floor plans, designer finishes, and delightful amenities, picture yourself living here in your dream home!",
  "property_interactivemap_blurb": "At Villas at Old 441 in Demorest, GA, your dream apartment awaits! Choose from spacious one, two, or three-bedroom floor plans featuring chef-inspired kitchens and designer finishes. Enjoy top-notch amenities like a sparkling swimming pool, fitness center, and bark park. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "At Villas at Old 441 in Demorest, GA, your furry friends are part of the family! With a pet-friendly policy allowing up to two cats or dogs for just $25 each month, you can enjoy life in our charming community without leaving your beloved companions behind. Welcome home!",
  "property_referafriend_blurb": "At Villas at Old 441 in Demorest, GA, spacious one, two, and three-bedroom floor plans await you. Share the joy of your exceptional living experience—great friends make great neighbors! Refer a friend today and build your ideal community together. Your next adventure starts here!",
  "property_residentaccess_blurb": "Welcome to Villas at Old 441 in Demorest, GA, where comfort meets community. Choose from spacious one, two, or three-bedroom apartments designed for your lifestyle. Ready for convenience? Access your resident portal to easily pay rent, schedule maintenance, and enjoy all the perks of apartment living in just a few clicks!",
  "property_reviews_blurb": "At Villas at Old 441 in Demorest, GA, our residents appreciate the vibrant community atmosphere, with one declaring, \"Living here feels like home!\" Join us and experience this exceptional lifestyle for yourself. See what our residents have to say about living at our community!",
  "property_created_at": "1775747828447",
  "property_scheduletour_blurb": "At Villas at Old 441 in Demorest, GA, your ideal home awaits—whether you seek a cozy one-bedroom, a spacious two-bedroom, or a luxurious three-bedroom. Dive into the vibrant community life and see what our residents love most. Schedule a tour today and envision your perfect living space!",
  "property_thankyou_blurb": "Thank you for choosing Villas at Old 441 in Demorest, GA! With thoughtfully designed one, two, and three-bedroom floor plans, your perfect home awaits. A dedicated team member will reach out soon to assist you in unlocking a lifestyle of comfort and convenience. Prepare to elevate your living experience!",
  "property_virtualtours_blurb": "At Villas at Old 441 in Demorest, GA, your ideal living space awaits. From cozy one-bedroom retreats to spacious three-bedroom havens, our thoughtfully designed floor plans cater to your lifestyle. Experience a glimpse of your future home—take a virtual tour today and imagine your new beginning!",
  "property_copyright": "2026 All Rights Reserved. Villas at Old 441",
  "property_seo_title_home": "Villas at Old 441 |  Apartments in Demorest, GA",
  "property_seo_description_home": "Welcome to Villas at Old 441 in Demorest, GA! Enjoy spacious layouts, designer finishes, and amenities like a pool, gym, and bark park!",
  "property_seo_title_floorplans": "Floor Plans | Demorest, GA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Villas at Old 441 in Demorest, GA! Choose from one, two, or three-bedroom floor plans tailored for comfort and style.",
  "property_seo_title_amenities": "Amenities | Demorest, GA Apartments for Rent",
  "property_seo_description_amenities": "Elevate your lifestyle at Villas at Old 441 in Demorest, GA! Enjoy a sparkling pool, beer garden, playground, and modern interiors. Your dream home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Demorest, GA",
  "property_seo_description_gallery": "Picture life at Villas at Old 441 in Demorest, GA! View our stunning photo gallery showcasing spacious floor plans, stylish amenities, and a vibrant community.",
  "property_seo_title_virtualtours": "Virtual Tours | Villas at Old 441 Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Villas at Old 441 in Demorest, GA. Take a virtual tour of our stunning one, two, and three-bedroom apartments for rent today!",
  "property_seo_title_interactivemap": "Interactive Map | Villas at Old 441 Apartments",
  "property_seo_description_interactivemap": "Find your dream home at Villas at Old 441 in Demorest, GA! Enjoy spacious floor plans and top-notch amenities. Use our interactive map to start your journey!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Demorest, GA",
  "property_seo_description_neighborhood": "Uncover Demorest’s hidden gems at Villas at Old 441! Immerse yourself in our vibrant neighborhood and discover local favorites just steps from home.",
  "property_seo_title_contact": "Contact Us | Villas at Old 441",
  "property_seo_description_contact": "Uncover your perfect home at Villas at Old 441, Demorest, GA. From cozy one-bedrooms to spacious three-bedrooms, reach out to our leasing team with questions!",
  "property_seo_title_faqs": "FAQs | Apartments in Demorest, GA",
  "property_seo_description_faqs": "Find answers to your questions about Villas at Old 441 in Demorest, GA. Explore spacious floor plans, exceptional amenities, and your new home awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Demorest, GA",
  "property_seo_description_reviews": "Discover the charm of Villas at Old 441 in Demorest, GA! Read resident reviews to see why our spacious homes and amenities are the perfect choice!",
  "property_seo_title_applynow": "Apply Now | Apartments in Demorest, GA",
  "property_seo_description_applynow": "Experience modern living at Villas at Old 441 in Demorest, GA! Choose from spacious 1-3 bedroom plans with luxury amenities. Apply online for your new home!",
  "property_seo_title_residentaccess": "Resident Access | Villas at Old 441",
  "property_seo_description_residentaccess": "Stay connected at Villas at Old 441 in Demorest, GA! Log in to your resident portal for easy rent payments and maintenance requests.",
  "property_seo_title_referafriend": "Refer A Friend | Villas at Old 441",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Villas at Old 441 in Demorest, GA, and enjoy life in a vibrant community together!",
  "property_seo_title_scheduletour": "Schedule a Tour | Villas at Old 441",
  "property_seo_description_scheduletour": "Experience the charm of Villas at Old 441 in Demorest, GA. Schedule your tour today and step into your dream apartment surrounded by community and comfort!",
  "property_seo_title_privacy": "Privacy Policy | Villas at Old 441",
  "property_seo_description_privacy": "Your privacy matters at Villas at Old 441 in Demorest, GA. Read our policy to learn how we protect your information while you enjoy your home.",
  "property_seo_title_accessibility": "Website Accessibility | Villas at Old 441",
  "property_seo_description_accessibility": "Experience true digital inclusion at Villas at Old 441. Our commitment to accessibility ensures every resident in Demorest, GA feels right at home.",
  "property_seo_title_sitemap": "Sitemap | Villas at Old 441",
  "property_seo_description_sitemap": "Uncover the charm of Villas at Old 441 in Demorest, GA. Navigate our sitemap to find your perfect home and amenities tailored just for you!",
  "property_seo_title_thankyou": "Thank You | Villas at Old 441",
  "property_seo_description_thankyou": "Thank you for reaching out to Villas at Old 441 in Demorest, GA! Expect a prompt response from our team to help you find your perfect home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Demorest, GA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1790793472949",
  "amenities": [
    {
      "id": "custom_61e9f5d1-eba2-4916-9919-81c47d308f5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "external_id": "false",
      "title": "Sparkling Swimming Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_327f613f-dae8-4417-8e55-3c197619419c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "external_id": "false",
      "title": "Beer Garden",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eaab90f6-a5cb-4b8a-93e8-1d0f24b8379c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8feca7c7-b069-4fee-a1e0-ec78d1e505e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "external_id": "false",
      "title": "Bark Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a485ee50-3580-466a-9aee-0dbba738afb8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dec70ce0-8e0e-4e54-a240-42bf51def795",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c2a7f51e-b331-49b2-8f9a-a732250896bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a54ae35c-7cd8-4d08-9681-7b767aa42146",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "external_id": "false",
      "title": "Granite Counters",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d16ac4da-4442-4d8a-a0fd-34507b603f5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "external_id": "false",
      "title": "Wood-Style Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6d0c8bd4-a170-4f9b-9aa8-e536fd48036a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Floor Plans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c7dd1d4c-d248-4995-9461-d7496d25a0cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "external_id": "false",
      "title": "Chef‑Inspired Kitchen",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2c110901-65c9-4cba-a2a5-69c39ca4dfd9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "external_id": "false",
      "title": "Designer Finishes",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f7b94e5d-e41a-4a72-bb1d-523bcdab4feb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "external_id": "false",
      "title": "Washer / Dryer Included",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_e9d13f7f-778f-41a8-86ec-4a831dc640aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019e02f8-7d32-75de-984f-a513c4ca4e3d.webp",
      "image_media": {
        "alt_text": "Exterior of a modern apartment building with white siding and blue trim, featuring balconies and a parking lot.",
        "public_id": "019e02f8-7d32-75de-984f-a513c4ca4e3d",
        "storage_key": "property/6767906449167445/019e02f8-7d32-75de-984f-a513c4ca4e3d.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Showcasing the sleek exterior of this modern apartment community, complete with private balconies and ample parking for residents.",
      "link": "",
      "alt_text": "Exterior of a modern apartment building with white siding and blue trim, featuring balconies and a parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b5bf36b6-24ca-434d-b9e9-b62f608b8f94",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019e02f8-7a2b-7466-b7af-ad8dfb25e43b.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with a large parking lot in front.",
        "public_id": "019e02f8-7a2b-7466-b7af-ad8dfb25e43b",
        "storage_key": "property/6767906449167445/019e02f8-7a2b-7466-b7af-ad8dfb25e43b.webp",
        "width": 1125,
        "height": 844
      },
      "title": "Community",
      "description": "Modern apartment buildings with ample parking and well-maintained grounds. A perfect place to call home.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with a large parking lot in front.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_671a5097-e4c0-48e6-a796-ebe5b4d72318",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019fe962-5eb0-777f-a44c-54f6a18fa4ea.webp",
      "image_media": {
        "alt_text": "Modern bathroom with granite countertop, sink, toilet, and shower with white curtain.",
        "public_id": "019fe962-5eb0-777f-a44c-54f6a18fa4ea",
        "storage_key": "property/6767906449167445/019fe962-5eb0-777f-a44c-54f6a18fa4ea.webp",
        "width": 2768,
        "height": 1560
      },
      "title": "Apartment",
      "description": "Experience the comfort of this modern bathroom, featuring a stylish granite countertop, a clean white sink, and a convenient toilet. The shower area is enclosed with a white curtain for privacy.",
      "link": "",
      "alt_text": "Modern bathroom with granite countertop, sink, toilet, and shower with white curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7324757a-60ad-4123-ac1f-0e63b5c7d5ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019fe962-5d63-71bd-b161-ca21b0e65923.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, green bedding, and a window overlooking trees.",
        "public_id": "019fe962-5d63-71bd-b161-ca21b0e65923",
        "storage_key": "property/6767906449167445/019fe962-5d63-71bd-b161-ca21b0e65923.webp",
        "width": 2768,
        "height": 1560
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom featuring a queen-size bed with plush green bedding and a large window offering serene views of the surrounding nature.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, green bedding, and a window overlooking trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5235da08-5137-4376-8288-1f5533b214e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019fe962-5c8f-71ad-af32-605507f6eccf.webp",
      "image_media": {
        "alt_text": "Empty closet with wire shelving and a laundry basket.",
        "public_id": "019fe962-5c8f-71ad-af32-605507f6eccf",
        "storage_key": "property/6767906449167445/019fe962-5c8f-71ad-af32-605507f6eccf.webp",
        "width": 2768,
        "height": 1560
      },
      "title": "Apartment",
      "description": "Spacious closet with ample shelving and a convenient laundry basket, perfect for organizing your belongings.",
      "link": "",
      "alt_text": "Empty closet with wire shelving and a laundry basket.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_110fc755-7410-4c5d-bfa2-7d4acc7693cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019fe962-57e1-736b-93f9-a456aa46c635.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a bathtub, shower, toilet, and vanity with granite countertop.",
        "public_id": "019fe962-57e1-736b-93f9-a456aa46c635",
        "storage_key": "property/6767906449167445/019fe962-57e1-736b-93f9-a456aa46c635.webp",
        "width": 2768,
        "height": 1560
      },
      "title": "Apartment",
      "description": "Experience comfort and style in our modern bathrooms, featuring a bathtub/shower combo, sleek vanity with granite countertops, and elegant fixtures.",
      "link": "",
      "alt_text": "Modern bathroom with a bathtub, shower, toilet, and vanity with granite countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_65543a78-cb2a-4e7c-a285-db511664a963",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019fe962-5929-7261-bdce-5d1d3a4894a8.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, nightstand, and closet.",
        "public_id": "019fe962-5929-7261-bdce-5d1d3a4894a8",
        "storage_key": "property/6767906449167445/019fe962-5929-7261-bdce-5d1d3a4894a8.webp",
        "width": 2768,
        "height": 1560
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable bed, a stylish nightstand with a lamp, and convenient closet access.",
      "link": "",
      "alt_text": "Bedroom with a bed, nightstand, and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_92d48bd6-54db-4f84-8287-2ecb2b9667bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019fe962-57d8-75ba-bb74-b7062ba2d01a.webp",
      "image_media": {
        "alt_text": "Spacious living room and kitchen area with a modern island and comfortable seating.",
        "public_id": "019fe962-57d8-75ba-bb74-b7062ba2d01a",
        "storage_key": "property/6767906449167445/019fe962-57d8-75ba-bb74-b7062ba2d01a.webp",
        "width": 2768,
        "height": 1560
      },
      "title": "Apartment",
      "description": "Open-concept living space featuring a sleek kitchen island, plush seating, and abundant natural light, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Spacious living room and kitchen area with a modern island and comfortable seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_80bdace0-5d15-4030-887b-8881b705e2c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019fe962-525c-76f9-af46-83d0dbae4882.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island, stainless steel appliances, and granite countertops.",
        "public_id": "019fe962-525c-76f9-af46-83d0dbae4882",
        "storage_key": "property/6767906449167445/019fe962-525c-76f9-af46-83d0dbae4882.webp",
        "width": 2768,
        "height": 1560
      },
      "title": "Apartment",
      "description": "Experience culinary convenience in this beautifully appointed kitchen, featuring a spacious island with a sink, sleek cabinetry, and modern stainless steel appliances.",
      "link": "",
      "alt_text": "Modern kitchen with island, stainless steel appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8ab5a0ea-eec3-49cc-9833-6e0c30aa4851",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019fe962-50fa-7314-af58-343f9b4b6e3c.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen area with island seating.",
        "public_id": "019fe962-50fa-7314-af58-343f9b4b6e3c",
        "storage_key": "property/6767906449167445/019fe962-50fa-7314-af58-343f9b4b6e3c.webp",
        "width": 2768,
        "height": 1560
      },
      "title": "Apartment",
      "description": "A bright and airy open-concept living and kitchen space, perfect for entertaining.",
      "link": "",
      "alt_text": "Modern living room and kitchen area with island seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c33c617f-fca3-4e24-bbbf-032bd00bba50",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019fe962-469c-7624-8f17-793da43ea57a.webp",
      "image_media": {
        "alt_text": "Fenced-in grassy dog park area with benches and picnic table next to apartment buildings.",
        "public_id": "019fe962-469c-7624-8f17-793da43ea57a",
        "storage_key": "property/6767906449167445/019fe962-469c-7624-8f17-793da43ea57a.webp",
        "width": 2768,
        "height": 1560
      },
      "title": "Community",
      "description": "Enjoy our convenient on-site dog park, perfect for your furry friends to play and socialize.",
      "link": "",
      "alt_text": "Fenced-in grassy dog park area with benches and picnic table next to apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5011cc19-8f92-434d-b319-251e02ddf55a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019fe962-4660-76dd-8333-3bcd6591f5b0.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines, weight machines, and free weights.",
        "public_id": "019fe962-4660-76dd-8333-3bcd6591f5b0",
        "storage_key": "property/6767906449167445/019fe962-4660-76dd-8333-3bcd6591f5b0.webp",
        "width": 2768,
        "height": 1560
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with treadmills, ellipticals, weight machines, and free weights for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with cardio machines, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3d548401-27d9-4cf4-a056-ca061ad4ecbe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019fe962-465c-70e1-bfe0-e585bc7c015e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops and stainless steel appliances, featuring an island with bar stools.",
        "public_id": "019fe962-465c-70e1-bfe0-e585bc7c015e",
        "storage_key": "property/6767906449167445/019fe962-465c-70e1-bfe0-e585bc7c015e.webp",
        "width": 2768,
        "height": 1560
      },
      "title": "Apartment",
      "description": "Step into this stylish apartment kitchen, boasting sleek gray cabinetry, granite countertops, and a spacious island perfect for casual dining. Fully equipped with modern stainless steel appliances.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops and stainless steel appliances, featuring an island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_93c7c1c9-5fbf-4b3e-8043-256120509a16",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019fe962-3b5e-75b8-b69b-dc7f7f74c374.webp",
      "image_media": {
        "alt_text": "Outdoor fire pit area with Adirondack chairs and two pergolas.",
        "public_id": "019fe962-3b5e-75b8-b69b-dc7f7f74c374",
        "storage_key": "property/6767906449167445/019fe962-3b5e-75b8-b69b-dc7f7f74c374.webp",
        "width": 2768,
        "height": 1560
      },
      "title": "Community",
      "description": "Gather around the stone fire pit surrounded by comfortable Adirondack chairs, perfect for evening relaxation under the pergolas.",
      "link": "",
      "alt_text": "Outdoor fire pit area with Adirondack chairs and two pergolas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0c2526ce-003f-4d76-9853-d96ea1e305f9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019fe962-466d-70a9-816a-0f55e9f59118.webp",
      "image_media": {
        "alt_text": "Playground with swings and slide, and covered seating area next to apartment building.",
        "public_id": "019fe962-466d-70a9-816a-0f55e9f59118",
        "storage_key": "property/6767906449167445/019fe962-466d-70a9-816a-0f55e9f59118.webp",
        "width": 1670,
        "height": 941
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the playground, or relax in the covered seating area, surrounded by lush greenery.",
      "link": "",
      "alt_text": "Playground with swings and slide, and covered seating area next to apartment building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_da67017e-f0b8-4afd-8018-b9134fe62e56",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019fe962-4688-7739-8dc3-8bbe4e635dee.webp",
      "image_media": {
        "alt_text": "Covered patio with outdoor seating area including a sofa, two chairs, and a coffee table.",
        "public_id": "019fe962-4688-7739-8dc3-8bbe4e635dee",
        "storage_key": "property/6767906449167445/019fe962-4688-7739-8dc3-8bbe4e635dee.webp",
        "width": 1670,
        "height": 942
      },
      "title": "Apartment",
      "description": "Enjoy relaxing evenings on your private, covered patio, perfect for unwinding or entertaining guests.",
      "link": "",
      "alt_text": "Covered patio with outdoor seating area including a sofa, two chairs, and a coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_155cce6c-5451-42dc-b45b-0e89f2d152df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019fe962-3cee-7393-b477-2d9db94fd296.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island and dining area.",
        "public_id": "019fe962-3cee-7393-b477-2d9db94fd296",
        "storage_key": "property/6767906449167445/019fe962-3cee-7393-b477-2d9db94fd296.webp",
        "width": 2768,
        "height": 1560
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring granite countertops, stainless steel appliances, and ample cabinet space, adjacent to a dining area.",
      "link": "",
      "alt_text": "Modern kitchen with island and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6b8cac61-fdcc-4c38-a525-60285fe1a291",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019fe962-1d65-739c-87ab-9f6003c16f47.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with a central drive leading to parking areas.",
        "public_id": "019fe962-1d65-739c-87ab-9f6003c16f47",
        "storage_key": "property/6767906449167445/019fe962-1d65-739c-87ab-9f6003c16f47.webp",
        "width": 2768,
        "height": 1560
      },
      "title": "Community",
      "description": "Beautifully designed apartment exteriors and community grounds, offering a welcoming and accessible living environment.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with a central drive leading to parking areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d9b9264c-a5c4-4634-beb9-37d64ee9ce57",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019fe962-1f57-71b3-b715-243bd3c7e001.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings.",
        "public_id": "019fe962-1f57-71b3-b715-243bd3c7e001",
        "storage_key": "property/6767906449167445/019fe962-1f57-71b3-b715-243bd3c7e001.webp",
        "width": 2768,
        "height": 1560
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge seating and lush landscaping. Perfect for relaxation and fun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_01f32b06-474d-4fcd-8cd8-1762ac2472ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019fe962-193a-735d-8305-03c9c3e79982.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a cabana.",
        "public_id": "019fe962-193a-735d-8305-03c9c3e79982",
        "storage_key": "property/6767906449167445/019fe962-193a-735d-8305-03c9c3e79982.webp",
        "width": 2768,
        "height": 1560
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and a shaded cabana area.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a cabana.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d3217c80-1432-4d60-a456-d979efd6090d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019fe962-1771-77ff-8381-9d87a6728eb8.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and buildings in the background.",
        "public_id": "019fe962-1771-77ff-8381-9d87a6728eb8",
        "storage_key": "property/6767906449167445/019fe962-1771-77ff-8381-9d87a6728eb8.webp",
        "width": 2768,
        "height": 1560
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_41c14d7b-d454-4564-8a13-6da2ca25eb93",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019ff652-7693-76b3-a27f-69f2644bd469.webp",
      "image_media": {
        "alt_text": "Property entrance with double doors and large windows.",
        "public_id": "019ff652-7693-76b3-a27f-69f2644bd469",
        "storage_key": "property/6767906449167445/019ff652-7693-76b3-a27f-69f2644bd469.webp",
        "width": 2768,
        "height": 1560
      },
      "title": "Community",
      "description": "Welcome to the property entrance, featuring double doors and large windows, complemented by lush landscaping.",
      "link": "",
      "alt_text": "Property entrance with double doors and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_a9e9943b-ae0a-47f3-875c-6d45aa508951",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "LongHorn Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "278 Carpenters Cove Ln, Cornelia, GA 30531, USA",
      "poi_short_description": "Casual steakhouse chain known for grilled beef & other American dishes in a ranch-style space.",
      "poi_long_description": "People say this steakhouse serves great burgers and delicious grilled salmon salad. They also highlight the friendly and attentive service, and the quick pick-up option.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d1-b44c-747e-8898-4d15d40a8099.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of Longhorn Steakhouse with a parking lot and blue sky.",
        "public_id": "019d72d1-b44c-747e-8898-4d15d40a8099",
        "storage_key": "property/6767906449167445/019d72d1-b44c-747e-8898-4d15d40a8099.webp",
        "width": 2313,
        "height": 3072
      },
      "poi_business_url": "https://www.longhornsteakhouse.com/locations/ga/cornelia/cornelia/5346?cmpid=br:lh_ag:ie_ch:loc_ca:LHGMB_sn:gmb_gt:cornelia-ga-5346_pl:locurl_rd:1292",
      "poi_directions_map_url": "https://maps.google.com/?cid=14801958498146758356&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "longhorn-steakhouse",
      "poi_latitude": "34.542135",
      "poi_longitude": "-83.539518",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 706-894-1576",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8e5f-760d-93fa-908548fd13be.webp",
      "poi_map_icon_media": {
        "alt_text": "Fork and knife icon",
        "public_id": "019d72d2-8e5f-760d-93fa-908548fd13be",
        "storage_key": "property/6767906449167445/019d72d2-8e5f-760d-93fa-908548fd13be.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7Vvuk1yyWIgR1K4cdtQea80",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_3cdd04a7-0a3d-4494-adce-935acc2cecf4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "330 Furniture Dr, Cornelia, GA 30531, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves fresh food. They highlight the fast and efficient service. They also like the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d1-b329-73cc-9945-15ebefa63bba.webp",
      "poi_featured_image_media": {
        "alt_text": "Chick-fil-A restaurant exterior with signage",
        "public_id": "019d72d1-b329-73cc-9945-15ebefa63bba",
        "storage_key": "property/6767906449167445/019d72d1-b329-73cc-9945-15ebefa63bba.webp",
        "width": 3072,
        "height": 1419
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ga/cornelia?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=17261423565964660891&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "34.5358664",
      "poi_longitude": "-83.5346871",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 706-776-0090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8e5f-760d-93fa-908548fd13be.webp",
      "poi_map_icon_media": {
        "alt_text": "Fork and knife icon",
        "public_id": "019d72d2-8e5f-760d-93fa-908548fd13be",
        "storage_key": "property/6767906449167445/019d72d2-8e5f-760d-93fa-908548fd13be.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5RcD22myWIgRm1DhPkfljO8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_a8aa5def-174a-450a-95f3-58a5eef35a29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "Bigg Daddys Restaurant and Tavern",
      "poi_type": "Restaurants",
      "poi_address": "137 Hodges St, Cornelia, GA 30531, USA",
      "poi_short_description": "Casual tavern with patio seating featuring classic American eats like burgers, wings and tacos plus beer.",
      "poi_long_description": "People say this restaurant serves delicious burgers, wings, and fish and chips. They also highlight the fun atmosphere, friendly and knowledgeable staff, and reasonable prices.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d1-b775-76ab-9a95-fa017c214f4f.webp",
      "poi_featured_image_media": {
        "alt_text": "Bigg Daddys restaurant and tavern exterior with signage and entrance.",
        "public_id": "019d72d1-b775-76ab-9a95-fa017c214f4f",
        "storage_key": "property/6767906449167445/019d72d1-b775-76ab-9a95-fa017c214f4f.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://biggdaddys.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15076182734144580908&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bigg-daddys-restaurant-and-tavern",
      "poi_latitude": "34.511646",
      "poi_longitude": "-83.528312",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 706-778-2739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8e5f-760d-93fa-908548fd13be.webp",
      "poi_map_icon_media": {
        "alt_text": "Fork and knife icon",
        "public_id": "019d72d2-8e5f-760d-93fa-908548fd13be",
        "storage_key": "property/6767906449167445/019d72d2-8e5f-760d-93fa-908548fd13be.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJH-xg1fStWIgRLK2Q1VFcOdE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_6c2b1175-a954-44e8-930b-bd2dd4efd8e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "Way2Baked",
      "poi_type": "Restaurants",
      "poi_address": "399 Cornelia Plaza Dr, Cornelia, GA 30531, USA",
      "poi_short_description": "Burger joint offering smashed patties , mini doughnuts, fries and other comfort grub.",
      "poi_long_description": "Diners say this restaurant serves up delicious smash burgers, loaded baked potatoes, and mini donuts. They also highlight the friendly staff and great service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d1-c731-755d-83c5-00446f2b8a65.webp",
      "poi_featured_image_media": {
        "alt_text": "Window display of various fast food illustrations including a hot dog, sandwich, hamburger, and platters of donuts.",
        "public_id": "019d72d1-c731-755d-83c5-00446f2b8a65",
        "storage_key": "property/6767906449167445/019d72d1-c731-755d-83c5-00446f2b8a65.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://way2baked.square.site/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12853443606132807342&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "way2baked",
      "poi_latitude": "34.5148765",
      "poi_longitude": "-83.529651",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 706-776-1050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8e5f-760d-93fa-908548fd13be.webp",
      "poi_map_icon_media": {
        "alt_text": "Fork and knife icon",
        "public_id": "019d72d2-8e5f-760d-93fa-908548fd13be",
        "storage_key": "property/6767906449167445/019d72d2-8e5f-760d-93fa-908548fd13be.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJK0NQZYKzWIgRrtYP_NuaYLI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_bd6dc6f5-a968-4ef2-82eb-ab8241fb9a9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "Fenders Diner",
      "poi_type": "Restaurants",
      "poi_address": "631 Irvin St, Cornelia, GA 30531, USA",
      "poi_short_description": "Casual 1950s-themed diner with burgers, fried chicken and deep-fried deviled eggs.",
      "poi_long_description": "People say this diner offers delicious smash burgers, boozy milkshakes, and fried deviled eggs. They also highlight the fun, old-timey vibe, and the friendly, attentive service.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d1-b468-7522-8ad3-b1d4c2ea5f78.webp",
      "poi_featured_image_media": {
        "alt_text": "Outdoor bar and patio seating area with tables and chairs.",
        "public_id": "019d72d1-b468-7522-8ad3-b1d4c2ea5f78",
        "storage_key": "property/6767906449167445/019d72d1-b468-7522-8ad3-b1d4c2ea5f78.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.fendersrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6719947903386146859&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fenders-diner",
      "poi_latitude": "34.5111834",
      "poi_longitude": "-83.5278967",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 706-776-2181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8e5f-760d-93fa-908548fd13be.webp",
      "poi_map_icon_media": {
        "alt_text": "Fork and knife icon",
        "public_id": "019d72d2-8e5f-760d-93fa-908548fd13be",
        "storage_key": "property/6767906449167445/019d72d2-8e5f-760d-93fa-908548fd13be.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3xbU1vStWIgRK1h2qgMNQl0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_5616a44f-19bc-44b4-aa11-2730ba883585",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "281 Carpenters Cove Ln, Cornelia, GA 30531, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store is clean, well-stocked, and has friendly and helpful staff. They also highlight the easy pick up order process and the availability of parking.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d1-b010-75ce-8540-7d426786f10b.webp",
      "poi_featured_image_media": {
        "alt_text": "The Lowe's logo on the exterior of a building.",
        "public_id": "019d72d1-b010-75ce-8540-7d426786f10b",
        "storage_key": "property/6767906449167445/019d72d1-b010-75ce-8540-7d426786f10b.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/GA-Cornelia/1925?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1925-_-na-_-0-_-0&y_source=1_MTE4Mzg1OC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=17557133606430659271&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "34.542457",
      "poi_longitude": "-83.538933",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 706-894-3960",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8f0e-7534-bb3b-55aacefec8dc.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019d72d2-8f0e-7534-bb3b-55aacefec8dc",
        "storage_key": "property/6767906449167445/019d72d2-8f0e-7534-bb3b-55aacefec8dc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJGWsjVUOyWIgRx1JfTf53p_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_e37b6b47-bd08-4bbc-8a68-1c6d5229fae2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "Ingles Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "199 E Louise St, Clarkesville, GA 30523, USA",
      "poi_short_description": "Chain market offering a large selection of produce and local options, plus a bakery and in-store Starbucks.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d1-b092-71ce-8e00-7d706674dd8e.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of an Ingles grocery store with a cafe and fresh foods section.",
        "public_id": "019d72d1-b092-71ce-8e00-7d706674dd8e",
        "storage_key": "property/6767906449167445/019d72d1-b092-71ce-8e00-7d706674dd8e.webp",
        "width": 800,
        "height": 364
      },
      "poi_business_url": "https://www.ingles-markets.com/storelocate/storeinfo.php?storenum=428",
      "poi_directions_map_url": "https://maps.google.com/?cid=5032321380169091144&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ingles-market",
      "poi_latitude": "34.6035606",
      "poi_longitude": "-83.51845829999999",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 706-754-3525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8e60-7052-a615-8fccc3057556.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d72d2-8e60-7052-a615-8fccc3057556",
        "storage_key": "property/6767906449167445/019d72d2-8e60-7052-a615-8fccc3057556.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf16v1QC0WIgRSAiVBKJl1kU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_a05d572b-5840-4399-af98-43027210bc1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "441 Antique Mall in the Old Clarkesville Mill",
      "poi_type": "Shopping & Retail",
      "poi_address": "583 Grant St, Clarkesville, GA 30523, USA",
      "poi_short_description": "Vast antique mall and museum featuring furniture, cars, tools and collectibles.",
      "poi_long_description": "People say this antique store offers a wide variety of items, including vintage clothing, books, tools, furniture, and more. They also highlight the reasonable prices, fun and interesting atmosphere, and the convenient location with nearby attractions like a car museum and bowling alley.\n\nOther reviews mention the selection can be overwhelming.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d1-c6bf-7526-ba44-7a9e9635523b.webp",
      "poi_featured_image_media": {
        "alt_text": "Brick building with \"ART & ANTIQUES\" and \"ANTIQUE MALL ENTER HERE\" signage, parking lot in front.",
        "public_id": "019d72d1-c6bf-7526-ba44-7a9e9635523b",
        "storage_key": "property/6767906449167445/019d72d1-c6bf-7526-ba44-7a9e9635523b.webp",
        "width": 3072,
        "height": 1493
      },
      "poi_business_url": "https://www.instagram.com/oldclarkesvilleantiques/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3134897894248976152&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "441-antique-mall-in-the-old-clarkesville-mill",
      "poi_latitude": "34.6184005",
      "poi_longitude": "-83.5196187",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 706-839-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8f0e-7534-bb3b-55aacefec8dc.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019d72d2-8f0e-7534-bb3b-55aacefec8dc",
        "storage_key": "property/6767906449167445/019d72d2-8f0e-7534-bb3b-55aacefec8dc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJB3rZxhC0WIgRGI_UgQZlgSs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_3d46c807-e5f7-4087-8fc2-bc3299411c95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "246 Habersham Hills Cir, Cornelia, GA 30531, USA",
      "poi_short_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_long_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d1-b069-74be-8976-731f67983484.webp",
      "poi_featured_image_media": {
        "alt_text": "Ross Dress for Less store exterior with signage.",
        "public_id": "019d72d1-b069-74be-8976-731f67983484",
        "storage_key": "property/6767906449167445/019d72d1-b069-74be-8976-731f67983484.webp",
        "width": 1473,
        "height": 830
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17963093323105891059&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "34.5443134",
      "poi_longitude": "-83.54257679999999",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 706-776-0006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8f0e-7534-bb3b-55aacefec8dc.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019d72d2-8f0e-7534-bb3b-55aacefec8dc",
        "storage_key": "property/6767906449167445/019d72d2-8f0e-7534-bb3b-55aacefec8dc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ13CnjACzWIgR8_LqbjS6Sfk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_df4f5d04-86f5-4429-9bbc-74570e2a5771",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "Piedmont University",
      "poi_type": "Education",
      "poi_address": "1021 Central Ave, Demorest, GA 30535, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d1-ddcc-770e-b975-5aa5d091cd82.webp",
      "poi_featured_image_media": {
        "alt_text": "Brick building with white columns and a steeple, surrounded by lush green landscaping and trees.",
        "public_id": "019d72d1-ddcc-770e-b975-5aa5d091cd82",
        "storage_key": "property/6767906449167445/019d72d1-ddcc-770e-b975-5aa5d091cd82.webp",
        "width": 3072,
        "height": 2044
      },
      "poi_business_url": "http://www.piedmont.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12823006978038519784&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "piedmont-university",
      "poi_latitude": "34.5665363",
      "poi_longitude": "-83.5419975",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 706-778-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8e5f-760d-93fa-8e08b9a3a09b.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d72d2-8e5f-760d-93fa-8e08b9a3a09b",
        "storage_key": "property/6767906449167445/019d72d2-8e5f-760d-93fa-8e08b9a3a09b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq-Ex96qzWIgR6FdXRuh49LE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_e37c3ef6-e6dc-4610-a580-84088a568364",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "North Georgia Technical College",
      "poi_type": "Education",
      "poi_address": "1500 GA-197, Clarkesville, GA 30523, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d1-d9dc-743d-a2ce-beb65886aa4d.webp",
      "poi_featured_image_media": {
        "alt_text": "Aerial view of a sprawling campus with multiple brick buildings, vast parking lots, and surrounding greenery under a clear blue sky.",
        "public_id": "019d72d1-d9dc-743d-a2ce-beb65886aa4d",
        "storage_key": "property/6767906449167445/019d72d1-d9dc-743d-a2ce-beb65886aa4d.webp",
        "width": 1200,
        "height": 674
      },
      "poi_business_url": "http://northgatech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14229758330637962964&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "north-georgia-technical-college",
      "poi_latitude": "34.6376978",
      "poi_longitude": "-83.52614020000001",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 706-754-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8e5f-760d-93fa-8e08b9a3a09b.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d72d2-8e5f-760d-93fa-8e08b9a3a09b",
        "storage_key": "property/6767906449167445/019d72d2-8e5f-760d-93fa-8e08b9a3a09b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkwJ9O0q0WIgR1M5UKc9BesU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_0498b5a9-2e9a-42d3-8ac4-3608ac307aae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "Miles Through Time Automotive Museum",
      "poi_type": "Entertainment",
      "poi_address": "583 Grant St, Clarkesville, GA 30523, USA",
      "poi_short_description": "History-focused car museum showcasing over 100 years of automotive makes and models, as well as auto memorabilia.",
      "poi_long_description": "People say this museum offers a great collection of vintage cars and vehicles, as well as antiques. They highlight the informative displays, the mint condition of the cars, and the variety of new and old vehicles. They also like the friendly and professional staff, and the opportunity to join tours that explain the history of the vehicles.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d1-df04-7282-b778-eb672ed63874.webp",
      "poi_featured_image_media": {
        "alt_text": "Classic blue convertible car on display in a showroom.",
        "public_id": "019d72d1-df04-7282-b778-eb672ed63874",
        "storage_key": "property/6767906449167445/019d72d1-df04-7282-b778-eb672ed63874.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://milesthroughtime.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18394447978694903562&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "miles-through-time-automotive-museum",
      "poi_latitude": "34.6193026",
      "poi_longitude": "-83.5192833",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 470-239-0199",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8e6b-71a2-8bc3-5062adb7f7ae.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon with letter M inside.",
        "public_id": "019d72d2-8e6b-71a2-8bc3-5062adb7f7ae",
        "storage_key": "property/6767906449167445/019d72d2-8e6b-71a2-8bc3-5062adb7f7ae.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJT2yJIha8WIgRCgeDifo0Rv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_601b90c4-5ff8-4ea7-a4f6-372f37012154",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "Chenocetah Lookout Tower",
      "poi_type": "Entertainment",
      "poi_address": "Cornelia, GA 30531, USA",
      "poi_short_description": "Lakeside, historic stone tower, also known as Chenocetah Lookout, offering valley and mountain views.",
      "poi_long_description": "People say this historical landmark offers beautiful views of the river and surrounding countryside. They highlight the scenic and relaxing walk up to the tower, and the cool historical plaques along the way. They also like the well-maintained grounds and the availability of picnic benches for a quick picnic.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d1-dea2-774f-bc04-bd5b706c19de.webp",
      "poi_featured_image_media": {
        "alt_text": "Stone tower with blue door and surrounding trees under a clear blue sky.",
        "public_id": "019d72d1-dea2-774f-bc04-bd5b706c19de",
        "storage_key": "property/6767906449167445/019d72d1-dea2-774f-bc04-bd5b706c19de.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.exploregeorgia.org/cornelia/general/historic-sites-trails-tours/chenocetah-fire-tower",
      "poi_directions_map_url": "https://maps.google.com/?cid=1789924090484925945&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chenocetah-lookout-tower",
      "poi_latitude": "34.5021193",
      "poi_longitude": "-83.5067857",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8ece-7229-a4c7-b73a20c0edbf.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d72d2-8ece-7229-a4c7-b73a20c0edbf",
        "storage_key": "property/6767906449167445/019d72d2-8ece-7229-a4c7-b73a20c0edbf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyQO_4geuWIgR-aVEFHoW1xg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_27388b68-accb-48ce-bfa5-de05d919ff7e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "The Big Red Apple",
      "poi_type": "Entertainment",
      "poi_address": "141 Clarkesville St NW, Cornelia, GA 30531, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this historical landmark features a unique downtown sculpture and a small, interesting museum. They also highlight the fun train cars and the festive decorations during the holidays.\n\nOther reviews mention the apple can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d1-edbf-749d-942a-369f71b44011.webp",
      "poi_featured_image_media": {
        "alt_text": "Big Red Apple monument in Cornelia, Georgia, with a train station and a child in the background.",
        "public_id": "019d72d1-edbf-749d-942a-369f71b44011",
        "storage_key": "property/6767906449167445/019d72d1-edbf-749d-942a-369f71b44011.webp",
        "width": 1620,
        "height": 912
      },
      "poi_business_url": "https://discovercornelia.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15527716481609579959&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-big-red-apple",
      "poi_latitude": "34.5116641",
      "poi_longitude": "-83.52661320000001",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 706-778-8585",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8ece-7229-a4c7-b73a20c0edbf.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d72d2-8ece-7229-a4c7-b73a20c0edbf",
        "storage_key": "property/6767906449167445/019d72d2-8ece-7229-a4c7-b73a20c0edbf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH_fPHfWtWIgRtz1R496Hfdc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_f4884bf1-93d2-445a-b434-6fb27e01ddb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "Loudermilk Field",
      "poi_type": "Entertainment",
      "poi_address": "204 Dorm Dr #200, Demorest, GA 30535, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d1-f1c1-76b9-b9f8-5184a90d99d1.webp",
      "poi_featured_image_media": {
        "alt_text": "Loudermilk Field baseball stadium with spectators in the stands and players on the field.",
        "public_id": "019d72d1-f1c1-76b9-b9f8-5184a90d99d1",
        "storage_key": "property/6767906449167445/019d72d1-f1c1-76b9-b9f8-5184a90d99d1.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.piedmontlions.com/sports/2011/1/4/GEN_0104115659.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=7480120056576021746&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loudermilk-field",
      "poi_latitude": "34.561657",
      "poi_longitude": "-83.54228739999999",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8e6c-768e-a15b-21c1d2290d8b.webp",
      "poi_map_icon_media": {
        "alt_text": "Two people sitting at a table icon.",
        "public_id": "019d72d2-8e6c-768e-a15b-21c1d2290d8b",
        "storage_key": "property/6767906449167445/019d72d2-8e6c-768e-a15b-21c1d2290d8b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXWyU5ayzWIgR8hR9YY-5zmc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_c1ccb426-32dc-4f63-ab3f-f7153a5e070f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "Loudermilk Boarding House & Everything Elvis Museum",
      "poi_type": "Entertainment",
      "poi_address": "271 Fore Acre St, Cornelia, GA 30531, USA",
      "poi_short_description": "Storied former boarding house dating to 1908 housing a quirky museum of Elvis-themed memorabilia.",
      "poi_long_description": "Storied former boarding house dating to 1908 housing a quirky museum of Elvis-themed memorabilia.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d1-f1b2-7756-b3b2-22c89064b7f5.webp",
      "poi_featured_image_media": {
        "alt_text": "A room decorated with Elvis Presley memorabilia, including posters, photos, and a mannequin wearing an Elvis-themed outfit.",
        "public_id": "019d72d1-f1b2-7756-b3b2-22c89064b7f5",
        "storage_key": "property/6767906449167445/019d72d1-f1b2-7756-b3b2-22c89064b7f5.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6736315462775555083&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loudermilk-boarding-house--everything-elvis-museum",
      "poi_latitude": "34.5116696",
      "poi_longitude": "-83.5243593",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 706-778-2001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8e6b-71a2-8bc3-5062adb7f7ae.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon with letter M inside.",
        "public_id": "019d72d2-8e6b-71a2-8bc3-5062adb7f7ae",
        "storage_key": "property/6767906449167445/019d72d2-8e6b-71a2-8bc3-5062adb7f7ae.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJlRWBtfWtWIgRC0S1DTkzfF0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_a41c14a9-4dcb-40d0-a8c8-39a5fc681af3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "365 Habersham Village Cir, Cornelia, GA 30531, USA",
      "poi_short_description": "Clean, low-cost chain gym offering massage chairs and hydro beds along with tanning.",
      "poi_long_description": "People say this gym offers a wide variety of cardio machines and well-maintained equipment. They highlight the clean facilities, reasonable prices, and welcoming, judgment-free atmosphere. They also like the friendly and professional staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-03a4-712d-87c4-c27c4c3d3ee1.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior view of a brightly lit gym with many people exercising on modern purple and yellow equipment.",
        "public_id": "019d72d2-03a4-712d-87c4-c27c4c3d3ee1",
        "storage_key": "property/6767906449167445/019d72d2-03a4-712d-87c4-c27c4c3d3ee1.webp",
        "width": 1920,
        "height": 1080
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/cornelia-ga?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=3390805937116884381&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "34.5395234",
      "poi_longitude": "-83.54314749999999",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 706-894-9292",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8ece-7229-a4c7-b73a20c0edbf.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d72d2-8ece-7229-a4c7-b73a20c0edbf",
        "storage_key": "property/6767906449167445/019d72d2-8ece-7229-a4c7-b73a20c0edbf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn3uJlTazWIgRnS0j2AiQDi8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a0f52341-2db3-4a73-8a57-cd350f99c3c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "Clarkesville Veterinary Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "6637 GA-115, Clarkesville, GA 30523, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-12f9-77b8-a865-dc26aa10001a.webp",
      "poi_featured_image_media": {
        "alt_text": "Clarkesville Veterinary sign and building exterior with rocking chairs on the porch.",
        "public_id": "019d72d2-12f9-77b8-a865-dc26aa10001a",
        "storage_key": "property/6767906449167445/019d72d2-12f9-77b8-a865-dc26aa10001a.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://clarkesvillevet.com/?utm_source=gmb&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=3094348828302332285&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "clarkesville-veterinary-hospital",
      "poi_latitude": "34.6138058",
      "poi_longitude": "-83.5353873",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 706-839-7387",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8ece-7229-a4c7-b73a20c0edbf.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d72d2-8ece-7229-a4c7-b73a20c0edbf",
        "storage_key": "property/6767906449167445/019d72d2-8ece-7229-a4c7-b73a20c0edbf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgxcxtZ60WIgRfVEbYt1V8So",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_6a2ebc70-c902-4983-a4aa-aa16f5ff4ee2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "Fades&Blades Barbershop",
      "poi_type": "Health and Wellness",
      "poi_address": "479 Hwy 441 Bypass Unit A, Baldwin, GA 30511, USA",
      "poi_short_description": "Walk-in barbershop offering haircuts and beard trims, including popular fades.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-0467-7229-8062-445f6d876f78.webp",
      "poi_featured_image_media": {
        "alt_text": "Barber shop with barber cutting client's hair.",
        "public_id": "019d72d2-0467-7229-8062-445f6d876f78",
        "storage_key": "property/6767906449167445/019d72d2-0467-7229-8062-445f6d876f78.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8883303742046053450&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fadesblades-barbershop",
      "poi_latitude": "34.4972945",
      "poi_longitude": "-83.5389584",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 706-239-6133",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8ece-7229-a4c7-b73a20c0edbf.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d72d2-8ece-7229-a4c7-b73a20c0edbf",
        "storage_key": "property/6767906449167445/019d72d2-8ece-7229-a4c7-b73a20c0edbf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-QEOjBKtWIgRSqSNCLDVR3s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_384548de-6055-4a97-99f9-e4705f2d01df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "A Nails Spa (20% OFF for Eyebrow Waxing)",
      "poi_type": "Health and Wellness",
      "poi_address": "273, Habersham CO Shopping Center, Cornelia, GA 30531, USA",
      "poi_short_description": "Primarily a nail salon, this establishment features dip powder.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-11c0-7048-b636-46d77012a2fc.webp",
      "poi_featured_image_media": {
        "alt_text": "Close-up of a woman's face with elaborate gold glitter and crystal-embellished nails, covering part of her face.",
        "public_id": "019d72d2-11c0-7048-b636-46d77012a2fc",
        "storage_key": "property/6767906449167445/019d72d2-11c0-7048-b636-46d77012a2fc.webp",
        "width": 750,
        "height": 750
      },
      "poi_business_url": "https://anailsspa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14099052885770532708&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "a-nails-spa-20-off-for-eyebrow-waxing",
      "poi_latitude": "34.5117226",
      "poi_longitude": "-83.5433039",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 762-239-9053",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8ece-7229-a4c7-b73a20c0edbf.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d72d2-8ece-7229-a4c7-b73a20c0edbf",
        "storage_key": "property/6767906449167445/019d72d2-8ece-7229-a4c7-b73a20c0edbf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI2fwo-KtWIgRZHfMTeblqcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_8754672e-7554-497e-9792-a3ddf4bc0c8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "Fade Factory Barbershop",
      "poi_type": "Health and Wellness",
      "poi_address": "700 US-441 BUS suite e, Cornelia, GA 30531, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-17a3-76ff-9346-2a8502e824ab.webp",
      "poi_featured_image_media": {
        "alt_text": "Child with 'VG' carved into the back of their hair, outdoors in autumn.",
        "public_id": "019d72d2-17a3-76ff-9346-2a8502e824ab",
        "storage_key": "property/6767906449167445/019d72d2-17a3-76ff-9346-2a8502e824ab.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17427660410610019130&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fade-factory-barbershop",
      "poi_latitude": "34.5339869",
      "poi_longitude": "-83.5332525",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 762-438-4831",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8ece-7229-a4c7-b73a20c0edbf.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d72d2-8ece-7229-a4c7-b73a20c0edbf",
        "storage_key": "property/6767906449167445/019d72d2-8ece-7229-a4c7-b73a20c0edbf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh0fPajmzWIgROmuMyM582_E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_d733c7b3-ed75-4904-9a10-df073b153036",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "Mill Creek Veterinary Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "277 Madison St, Clarkesville, GA 30523, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-13b2-76a8-ab1a-7a5a003b7860.webp",
      "poi_featured_image_media": {
        "alt_text": "Mill Creek Veterinary Hospital logo on brick building.",
        "public_id": "019d72d2-13b2-76a8-ab1a-7a5a003b7860",
        "storage_key": "property/6767906449167445/019d72d2-13b2-76a8-ab1a-7a5a003b7860.webp",
        "width": 3072,
        "height": 1960
      },
      "poi_business_url": "http://millcreek-vet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14128585169498373580&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mill-creek-veterinary-hospital",
      "poi_latitude": "34.612657",
      "poi_longitude": "-83.525296",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 706-839-1718",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8ece-7229-a4c7-b73a20c0edbf.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d72d2-8ece-7229-a4c7-b73a20c0edbf",
        "storage_key": "property/6767906449167445/019d72d2-8ece-7229-a4c7-b73a20c0edbf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh2Gbmw20WIgRzH3N7lrREsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_0787b0f2-ff43-4efa-921e-8c08b32bb7d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "Northeast Veterinary Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "120 Pet Care Ct, Cornelia, GA 30531, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-22fb-7784-8cc3-69dfa6cf30b6.webp",
      "poi_featured_image_media": {
        "alt_text": "Northeast Veterinary Hospital exterior with signage above the entrance.",
        "public_id": "019d72d2-22fb-7784-8cc3-69dfa6cf30b6",
        "storage_key": "property/6767906449167445/019d72d2-22fb-7784-8cc3-69dfa6cf30b6.webp",
        "width": 2048,
        "height": 1536
      },
      "poi_business_url": "https://nevethospital.com/?utm_source=gmb&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=722702525833141458&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "northeast-veterinary-hospital",
      "poi_latitude": "34.5351729",
      "poi_longitude": "-83.5392688",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 706-778-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8ece-7229-a4c7-b73a20c0edbf.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d72d2-8ece-7229-a4c7-b73a20c0edbf",
        "storage_key": "property/6767906449167445/019d72d2-8ece-7229-a4c7-b73a20c0edbf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRUV012eyWIgR0tyPQh6OBwo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_2c63129b-d248-4bf0-9d2e-6274e3ca70ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "Great Clips",
      "poi_type": "Health and Wellness",
      "poi_address": "282 Furniture Dr Ste B, Cornelia, GA 30531, USA",
      "poi_short_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_long_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-2087-70c8-9ff9-937a427a8329.webp",
      "poi_featured_image_media": {
        "alt_text": "Great Clips online check-in app on two iPhones showing salon locator and wait times.",
        "public_id": "019d72d2-2087-70c8-9ff9-937a427a8329",
        "storage_key": "property/6767906449167445/019d72d2-2087-70c8-9ff9-937a427a8329.webp",
        "width": 680,
        "height": 383
      },
      "poi_business_url": "https://salons.greatclips.com/us/ga/cornelia/282-furniture-plaza-dr?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=6390537655247139861&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-clips",
      "poi_latitude": "34.5372475",
      "poi_longitude": "-83.53308109999999",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 706-778-0282",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8ece-7229-a4c7-b73a20c0edbf.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d72d2-8ece-7229-a4c7-b73a20c0edbf",
        "storage_key": "property/6767906449167445/019d72d2-8ece-7229-a4c7-b73a20c0edbf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP0JH9WmyWIgRFXTDkCPAr1g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_993c712a-a976-4695-90c7-b6cb541c30a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "Cornelia Veterinary Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "785 Baldwin Rd, Cornelia, GA 30531, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-26ca-7109-b72f-ab91e9fc7cd7.webp",
      "poi_featured_image_media": {
        "alt_text": "A cute dog with its tongue sticking out.",
        "public_id": "019d72d2-26ca-7109-b72f-ab91e9fc7cd7",
        "storage_key": "property/6767906449167445/019d72d2-26ca-7109-b72f-ab91e9fc7cd7.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://corneliavet.com/?utm_source=gmb&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=16747745114348759784&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cornelia-veterinary-hospital",
      "poi_latitude": "34.5079565",
      "poi_longitude": "-83.546598",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 706-778-6605",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8ece-7229-a4c7-b73a20c0edbf.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d72d2-8ece-7229-a4c7-b73a20c0edbf",
        "storage_key": "property/6767906449167445/019d72d2-8ece-7229-a4c7-b73a20c0edbf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ808ZsoOtWIgR6KqKuXLxa-g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_d727ca28-0f2c-4e1f-aa77-2da84275a401",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "Grateful Head Salon",
      "poi_type": "Health and Wellness",
      "poi_address": "1370 Cannon Bridge Rd, Demorest, GA 30535, USA",
      "poi_short_description": "Boutique hair salon offering a range of services including haircuts, coloring, and extensions.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-360e-718e-9af4-ed4cc2345689.webp",
      "poi_featured_image_media": {
        "alt_text": "Group of people smiling and looking out of a dilapidated bus.",
        "public_id": "019d72d2-360e-718e-9af4-ed4cc2345689",
        "storage_key": "property/6767906449167445/019d72d2-360e-718e-9af4-ed4cc2345689.webp",
        "width": 1600,
        "height": 901
      },
      "poi_business_url": "https://www.facebook.com/Grateful-Head-648117715330043/",
      "poi_directions_map_url": "https://maps.google.com/?cid=212802919893067635&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "grateful-head-salon",
      "poi_latitude": "34.550722",
      "poi_longitude": "-83.56595399999999",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 706-760-6020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8ece-7229-a4c7-b73a20c0edbf.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d72d2-8ece-7229-a4c7-b73a20c0edbf",
        "storage_key": "property/6767906449167445/019d72d2-8ece-7229-a4c7-b73a20c0edbf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt1iYOO-yWIgRc2dkzyAH9AI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_48c585fb-d641-4b3f-b020-541d3de03e6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "Northeast Georgia Medical Center Habersham",
      "poi_type": "Health and Wellness",
      "poi_address": "541 Historic Hwy #441-N, Demorest, GA 30535, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-3420-7559-9276-35e0ea704525.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior building entrance with stone pillars and canopy at dusk.",
        "public_id": "019d72d2-3420-7559-9276-35e0ea704525",
        "storage_key": "property/6767906449167445/019d72d2-3420-7559-9276-35e0ea704525.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "https://www.nghs.com/locations/habersham",
      "poi_directions_map_url": "https://maps.google.com/?cid=18017164665344311651&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "northeast-georgia-medical-center-habersham",
      "poi_latitude": "34.5811102",
      "poi_longitude": "-83.5370317",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 706-754-2161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8e6d-76f8-910c-fc4b7d5419fe.webp",
      "poi_map_icon_media": {
        "alt_text": "H",
        "public_id": "019d72d2-8e6d-76f8-910c-fc4b7d5419fe",
        "storage_key": "property/6767906449167445/019d72d2-8e6d-76f8-910c-fc4b7d5419fe.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ-CjEsfaWIgRY0GR2c3TCfo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_04de3c37-6ae3-4a07-b0f1-9d1414815f5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "Windermere Medical Group | Primary Care Habersham",
      "poi_type": "Health and Wellness",
      "poi_address": "386 US-441, Baldwin, GA 30511, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-36de-77fc-acfe-06a3cfd3900a.webp",
      "poi_featured_image_media": {
        "alt_text": "Waiting area with chairs, coffee station, and restroom sign.",
        "public_id": "019d72d2-36de-77fc-acfe-06a3cfd3900a",
        "storage_key": "property/6767906449167445/019d72d2-36de-77fc-acfe-06a3cfd3900a.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://windermeremedical.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7243517466361009700&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "windermere-medical-group--primary-care-habersham",
      "poi_latitude": "34.4975963",
      "poi_longitude": "-83.5373201",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 706-407-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8e6d-76f8-910c-fc4b7d5419fe.webp",
      "poi_map_icon_media": {
        "alt_text": "H",
        "public_id": "019d72d2-8e6d-76f8-910c-fc4b7d5419fe",
        "storage_key": "property/6767906449167445/019d72d2-8e6d-76f8-910c-fc4b7d5419fe.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJCQkrLzStWIgRJBbJAsIkhmQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_69269997-6b6a-419b-b545-a676b8874704",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "Cornelia City Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "200 Lavista Ln, Cornelia, GA 30531, USA",
      "poi_short_description": "Park offering an off-leash zone for dogs, play equipment, a shaded walking trail & a picnic shelter.",
      "poi_long_description": "Park offering an off-leash zone for dogs, play equipment, a shaded walking trail & a picnic shelter.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-3b2c-75f8-b087-38d5e7c8c80b.webp",
      "poi_featured_image_media": {
        "alt_text": "Wooden boardwalk winding through a lush green forest with tall trees.",
        "public_id": "019d72d2-3b2c-75f8-b087-38d5e7c8c80b",
        "storage_key": "property/6767906449167445/019d72d2-3b2c-75f8-b087-38d5e7c8c80b.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://cornelia.city/living-visiting/city-parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12313641084754311268&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cornelia-city-park",
      "poi_latitude": "34.514428",
      "poi_longitude": "-83.517404",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 706-778-8585",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8ed6-7392-9fe1-7d1ed59f6bb1.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a Christmas tree",
        "public_id": "019d72d2-8ed6-7392-9fe1-7d1ed59f6bb1",
        "storage_key": "property/6767906449167445/019d72d2-8ed6-7392-9fe1-7d1ed59f6bb1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0SYG8QeyWIgRZLhvfFPX4qo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_cf68a572-828f-40f6-ae58-d7a3a1c163dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "Pitts Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "221 Sam Pitts Crk, Clarkesville, GA 30523, USA",
      "poi_short_description": "Picnicking, a playground, and a walking trail are among the attractions at this park with river views.",
      "poi_long_description": "People say this park offers a playground, a sand track, and a walking trail, and is located next to a creek. They also highlight the swings, exercise equipment, and picnic pavilions, and like the clean and well-maintained facilities.\n\nOther reviews mention the park can flood after rain.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-3b81-72f0-b0cd-4c767422d5f8.webp",
      "poi_featured_image_media": {
        "alt_text": "Playground with slides, merry-go-round, and swings surrounded by trees.",
        "public_id": "019d72d2-3b81-72f0-b0cd-4c767422d5f8",
        "storage_key": "property/6767906449167445/019d72d2-3b81-72f0-b0cd-4c767422d5f8.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.clarkesvillega.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4528010615265137492&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pitts-park",
      "poi_latitude": "34.6172491",
      "poi_longitude": "-83.52861320000001",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8ed6-7392-9fe1-7d1ed59f6bb1.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a Christmas tree",
        "public_id": "019d72d2-8ed6-7392-9fe1-7d1ed59f6bb1",
        "storage_key": "property/6767906449167445/019d72d2-8ed6-7392-9fe1-7d1ed59f6bb1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJfzvvkA20WIgRVJMTBqq51j4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_01d017dc-835f-4c22-a4f8-56cf16c9b3b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "Buck Shoals Wildlife Management Area",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "501 Buck Shoals Dr, Cleveland, GA 30528, USA",
      "poi_short_description": "Park and natural area with rapids, hiking trails and a picnic area for land lovers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-480a-72b9-8a53-2f67220cfecf.webp",
      "poi_featured_image_media": {
        "alt_text": "Scenic river flowing through a lush, tree-lined landscape with a bright blue sky.",
        "public_id": "019d72d2-480a-72b9-8a53-2f67220cfecf",
        "storage_key": "property/6767906449167445/019d72d2-480a-72b9-8a53-2f67220cfecf.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.exploregeorgia.org/listing/61965-buck-shoals-wildlife-management-area",
      "poi_directions_map_url": "https://maps.google.com/?cid=11395561942282686394&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "buck-shoals-wildlife-management-area",
      "poi_latitude": "34.5570716",
      "poi_longitude": "-83.6308524",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8ed6-7392-9fe1-7d1ed59f6bb1.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a Christmas tree",
        "public_id": "019d72d2-8ed6-7392-9fe1-7d1ed59f6bb1",
        "storage_key": "property/6767906449167445/019d72d2-8ed6-7392-9fe1-7d1ed59f6bb1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJLV9PBgRNX4gRuk-40TUrJZ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_09e59538-303b-4de1-8366-55cc14730303",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "Demorest Spring Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "559 Georgia St, Demorest, GA 30535, USA",
      "poi_short_description": "Shady tree-filled park with benches and a playground featuring swings, slides and other equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-479a-707b-af67-8b9b5beb6b81.webp",
      "poi_featured_image_media": {
        "alt_text": "Playground with slides, swings, and climbing structures surrounded by trees.",
        "public_id": "019d72d2-479a-707b-af67-8b9b5beb6b81",
        "storage_key": "property/6767906449167445/019d72d2-479a-707b-af67-8b9b5beb6b81.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8460876587452233181&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "demorest-spring-park",
      "poi_latitude": "34.5649903",
      "poi_longitude": "-83.54424279999999",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8ed6-7392-9fe1-7d1ed59f6bb1.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a Christmas tree",
        "public_id": "019d72d2-8ed6-7392-9fe1-7d1ed59f6bb1",
        "storage_key": "property/6767906449167445/019d72d2-8ed6-7392-9fe1-7d1ed59f6bb1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5Zu6qa6zWIgR3XWCu20Sa3U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_db20df30-5590-4116-83d7-75e36d6d57b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "Habersham County Park & Rec",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "120 Paul Franklin Rd, Clarkesville, GA 30523, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-53bf-735d-8b02-48ad4f6f43c4.webp",
      "poi_featured_image_media": {
        "alt_text": "People looking at a pirate ship ride at a carnival.",
        "public_id": "019d72d2-53bf-735d-8b02-48ad4f6f43c4",
        "storage_key": "property/6767906449167445/019d72d2-53bf-735d-8b02-48ad4f6f43c4.webp",
        "width": 1728,
        "height": 3072
      },
      "poi_business_url": "https://www.habershamga.com/parks-and-recreation.cfm",
      "poi_directions_map_url": "https://maps.google.com/?cid=7781644638063167426&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "habersham-county-park--rec",
      "poi_latitude": "34.6109117",
      "poi_longitude": "-83.50293669999999",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 706-839-0234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8ed6-7392-9fe1-7d1ed59f6bb1.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a Christmas tree",
        "public_id": "019d72d2-8ed6-7392-9fe1-7d1ed59f6bb1",
        "storage_key": "property/6767906449167445/019d72d2-8ed6-7392-9fe1-7d1ed59f6bb1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJRXioF6m2WIgRwgcUxJH0_Ws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4ad02712-74ec-4673-8124-f175b0e21e44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "Habersham County Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1112 Airport Rd, Cornelia, GA 30531, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-5f01-74e9-ac22-7455db80b147.webp",
      "poi_featured_image_media": {
        "alt_text": "A small blue and silver airplane is parked in front of the Habersham County Airport building.",
        "public_id": "019d72d2-5f01-74e9-ac22-7455db80b147",
        "storage_key": "property/6767906449167445/019d72d2-5f01-74e9-ac22-7455db80b147.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.habershamga.com/airport.cfm",
      "poi_directions_map_url": "https://maps.google.com/?cid=10686722517002455876&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "habersham-county-airport",
      "poi_latitude": "34.4986114",
      "poi_longitude": "-83.5547866",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 706-839-0247",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8e5e-705e-9e96-4836c3304ff4.webp",
      "poi_map_icon_media": {
        "alt_text": "Airplane icon",
        "public_id": "019d72d2-8e5e-705e-9e96-4836c3304ff4",
        "storage_key": "property/6767906449167445/019d72d2-8e5e-705e-9e96-4836c3304ff4.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJo14Zw3atWIgRRIsZL4LdTpQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_802265e9-e9c4-4699-989e-3a3acbd4702a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "Morito Scovill Americas",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1802 Scovill Drive, Clarkesville, GA 30523, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-7427-72ce-9218-f0facba76119.webp",
      "poi_featured_image_media": {
        "alt_text": "Morito Scovill building exterior with monument sign and American flag.",
        "public_id": "019d72d2-7427-72ce-9218-f0facba76119",
        "storage_key": "property/6767906449167445/019d72d2-7427-72ce-9218-f0facba76119.webp",
        "width": 3072,
        "height": 1419
      },
      "poi_business_url": "http://www.scovill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3072110696896247688&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "morito-scovill-americas",
      "poi_latitude": "34.597347",
      "poi_longitude": "-83.5248993",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 706-754-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-8ece-7229-a4c7-b73a20c0edbf.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d72d2-8ece-7229-a4c7-b73a20c0edbf",
        "storage_key": "property/6767906449167445/019d72d2-8ece-7229-a4c7-b73a20c0edbf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmdgb9POzWIgRiLct72ZUoio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_487e4c49-c0ef-41d3-a349-4e25d26a03de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "Clarkesville City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "123 Laurel Dr, Clarkesville, GA 30523, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-7106-70b8-9d43-a37d1b5a5e43.webp",
      "poi_featured_image_media": {
        "alt_text": "Building exterior with a covered walkway and brick facade.",
        "public_id": "019d72d2-7106-70b8-9d43-a37d1b5a5e43",
        "storage_key": "property/6767906449167445/019d72d2-7106-70b8-9d43-a37d1b5a5e43.webp",
        "width": 3072,
        "height": 1419
      },
      "poi_business_url": "http://www.clarkesvillega.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8561016289618140858&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "clarkesville-city-hall",
      "poi_latitude": "34.6104393",
      "poi_longitude": "-83.5212217",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 706-754-4216",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-946f-741f-ac72-5650b6d32052.webp",
      "poi_map_icon_media": {
        "alt_text": "Generic building icon",
        "public_id": "019d72d2-946f-741f-ac72-5650b6d32052",
        "storage_key": "property/6767906449167445/019d72d2-946f-741f-ac72-5650b6d32052.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8W48SRK0WIgRup4FC_XWznY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_1cc0b4bb-d333-46b5-b318-29cab70cc57b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "poi_name": "MOUNT AIRY CITY HALL",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1231 Dicks Hill Pkwy, Mt Airy, GA 30563, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.townofmtairy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9249596175924224067&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mount-airy-city-hall",
      "poi_latitude": "34.518757",
      "poi_longitude": "-83.4982313",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 706-778-6990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019d72d2-946f-741f-ac72-5650b6d32052.webp",
      "poi_map_icon_media": {
        "alt_text": "Generic building icon",
        "public_id": "019d72d2-946f-741f-ac72-5650b6d32052",
        "storage_key": "property/6767906449167445/019d72d2-946f-741f-ac72-5650b6d32052.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qaZPuxWIgRQ2DGLbcqXYA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    }
  ],
  "office_hours": [
    {
      "id": "ec_d822c646dfebd842e9f07721",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_9eac34e8059e53101f64af2d",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_f4e6e0c125e7f539fa6dd9bd",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_cb5b3d6f7c6e4256a0ad0150",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_ff917d921c67ef044d760979",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_cef83aac900fd58c6cd13ca5",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_90dd54dd-f994-4a19-9d6b-da02bcb964de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "rating": "5.0",
      "name": "Alejandra Perez Aiaz de Leon",
      "text": "This apartment is an excellent choice. It offers spacious and well-lit areas, ideal for relaxing in peace. It features a functional layout that includes a kitchen, bedroom, and bathroom—designed to provide comfort and ease in everyday living.\nIt’s a perfect place for those who value tranquility, privacy, and a great location.\nI highly recommend scheduling a visit—you're going to love it!",
      "date": "2025-07-21",
      "title": "false"
    },
    {
      "id": "custom_b5dc7e17-8b56-4a1d-8bb3-9bd3fe189117",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "rating": "5.0",
      "name": "Darrell Productions",
      "text": "One of the things I appreciate most is the peaceful atmosphere. Despite being close to Old 441, the community itself feels tucked away and quiet. My apartment is well-maintained with modern finishes and ample space. I especially enjoy the natural light, the balcony, the spacious kitchen.\n\nThe location is also a major plus. It's incredibly convenient to have easy access to shopping centers, great restaurants, major roads and parks. This makes running errands and commuting a breeze.\n\nI've also been impressed with the management and maintenance team. They are always responsive and helpful whenever I've had a question or needed assistance. Maintenance requests are handled promptly and efficiently.\n\nI really enjoy living at Villas at Old 441.\n\nDarrell",
      "date": "2025-03-20",
      "title": ""
    },
    {
      "id": "custom_bd325169-354a-4f37-bbdc-69fd315de92d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "rating": "5.0",
      "name": "Jamie Read",
      "text": "I recently worked with Jesus during my apartment search, and I must say, he was an absolute pleasure to work with. As a leasing manager, he was professional, friendly, and genuinely cared about finding the perfect apartment for me. He took the time to understand my preferences and budget, answering all my questions and providing valuable insights along the way.\n\nThanks to his dedication and attention to detail, Jesus found me an amazing apartment that met all my expectations. I would highly recommend his services to anyone in need of a caring and professional leasing manager!😊",
      "date": "2025-07-17",
      "title": ""
    },
    {
      "id": "custom_31ff2b8d-ef46-4743-a69a-c5bb960c8dbe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "rating": "5.0",
      "name": "April Kastner",
      "text": "The Villas at Old 441 is a great addition to Demorest! The property is clean and well maintained! The apartments themselves are very nice with granite countertops and love the furnished appliances! Love the outdoor deck space! Mireya, the Property Manager, is very helpful and handles issues quickly!",
      "date": "2025-03-20",
      "title": ""
    },
    {
      "id": "custom_a8cf20df-b6d7-4e63-8670-5ed9846d53f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "rating": "5.0",
      "name": "Salvador Arellano",
      "text": "We had to move very suddenly, and this was the first place we found. We were very happy with how quickly they were able to get us moved in. When we first arrived, we noticed that our apartment was very clean, well maintained, and move in ready. So far, we haven't had any issues at all.\nWe see the maintenance guys every morning keeping the property clean and looking great. A special thanks to Fatima and Amber in the leasing office for answering all of our questions and helping us get everything situated. They have been very helpful throughout the process.\nOverall, we are very happy with our apartment and our experience here. We would definitely recommend this community to others!",
      "date": "2026-06-25",
      "title": ""
    },
    {
      "id": "custom_2013104c-416c-4134-b61b-d284e5da1fc4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "rating": "5.0",
      "name": "Cory Loggins",
      "text": "Amber has been absolutely wonderful to work with. Every time I’ve called with a question or concern, she has been incredibly helpful, thorough, and responsive. She really takes the time to listen, explain things clearly, and make sure issues are handled properly instead of just brushed off.\n\nYou can tell she genuinely cares about the residents and takes pride in doing her job well. Good property managers are hard to find, and Amber consistently goes above and beyond with her communication, professionalism, and attention to detail. I truly appreciate all of her help and support!",
      "date": "2026-05-18",
      "title": ""
    },
    {
      "id": "custom_5e405568-9fd0-4836-962b-55aad0f65773",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "rating": "5.0",
      "name": "Jennifer Moorhead",
      "text": "Leasing staff were wonderful to work with and went above and beyond to find the right apartment for my son. Helpful each step of the process. Well maintained property with kind, friendly people to answer questions and provide correct information the first time. Amber and Fatima were both amazing!",
      "date": "2026-04-10",
      "title": ""
    },
    {
      "id": "custom_c5f774d8-5e13-4a9d-b6ef-9ef337452b5f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "rating": "5.0",
      "name": "Brenda Garcia",
      "text": "Great first impression. Really liked all the information provided regarding the apartment, management, amenities, etc. Amber was great, so communicative and thorough. Loved the apartment, very spacious and no need for appliances; best part it’s pet friendly.",
      "date": "2026-03-27",
      "title": ""
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db23f-df90-741f-a086-6dce36b29eb7",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Villas at Old 441 Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445"
    },
    {
      "lead_collector_id": "019db23f-e005-778f-9217-35f352599294",
      "lead_source": "FACEBOOK_ADS",
      "name": "Villas at Old 441 Facebook Ads",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445"
    },
    {
      "lead_collector_id": "019db23f-e079-774e-842c-0e402f37c0ec",
      "lead_source": "LANDING_PAGE",
      "name": "Villas at Old 441 Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "page_item_url": "villas-at-old-441-apartments-with-pool-demorest-ga",
      "search_query": "apartments with pool in Demorest GA",
      "category": "Amenity",
      "h1_title": "Villas with a Pool in Demorest, GA",
      "h2_subtitle": "Discover luxury living with a pool at Villas at Old 441. Perfectly situated in Demorest, GA, enjoy top-notch amenities and serene surroundings.",
      "page_copy": "Searching for apartments with a pool in Demorest, GA? Look no further than the charming Villas at Old 441. Set amidst the beautiful backdrop of Habersham County, our community offers residents access to a refreshing pool—ideal for relaxation and leisure.\n\nThe Villas at Old 441 go beyond just a pool. Indulge in a range of first-class amenities including a state-of-the-art fitness center, playground, and a unique beer garden. Each apartment features designer finishes and a chef-inspired kitchen, ensuring a living experience that crafts both comfort and style. Embrace the perfect blend of luxury and convenience right here in Demorest.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Villas with a Pool in Demorest, GA",
      "seo_description": "Explore the Villas at Old 441 with a pool in Demorest, GA. Enjoy a fitness center, playground, and more!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "page_item_url": "fitness-center-apartments-habersham-county-villas-at-old-441",
      "search_query": "fitness center apartments in Habersham County",
      "category": "Amenity",
      "h1_title": "Fitness-Centric Living in Habersham County",
      "h2_subtitle": "Experience premier fitness center apartments at Villas at Old 441. Located in scenic Habersham County, these homes are perfect for active living.",
      "page_copy": "If you're looking for fitness center apartments in Habersham County, Villas at Old 441 is the ideal destination. Nestled in the serene community of Demorest, GA, our apartments not only feature a top-notch fitness center but also offer a modern lifestyle filled with convenience and elegance.\n\nThe Villas at Old 441 offers a plethora of amenities beyond the fitness center. From meticulously designed interiors with chef-inspired kitchens to relaxing communal areas like the beer garden and playground, every detail is crafted with residents' happiness in mind. Dive into a community that values active and vibrant living—right here at Villas at Old 441.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Apartments in Habersham County",
      "seo_description": "Discover fitness center apartments in Habersham County at Villas at Old 441. Stylish homes with top amenities await.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "page_item_url": "dog-friendly-apartments-30535-villas-at-old-441",
      "search_query": "dog friendly apartments in 30535",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Living in Demorest, 30535",
      "h2_subtitle": "Discover your new home at Villas at Old 441, offering dog-friendly apartments in the 30535 area. Enjoy modern amenities perfect for pet owners.",
      "page_copy": "For those seeking dog-friendly apartments in the 30535 area, Villas at Old 441 is the perfect home for you and your furry friend. Located in the heart of Demorest, GA, our community offers not only a welcoming environment for pets but also a range of amenities that cater to both two-legged and four-legged residents.\n\nEnjoy spacious living spaces with designer finishes and a chef-inspired kitchen, ideal for cozy evenings at home. The surrounding community offers various activities, including a pleasant playground and a local beer garden. With a fitness center on-site, staying active is effortless. Come home to Villas at Old 441 and experience a welcoming community where pets are family.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments in 30535",
      "seo_description": "Villas at Old 441 offers dog-friendly living in Demorest's 30535 area. Enjoy amenities perfect for you and your pet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "page_item_url": "luxury-apartments-designer-finishes-demorest-villas-at-old-441",
      "search_query": "luxury apartments with designer finishes in Demorest",
      "category": "Amenity",
      "h1_title": "Luxury Apartments in Demorest with Designer Finishes",
      "h2_subtitle": "Discover luxury living with exquisite designer finishes at Villas at Old 441, nestled in the charming town of Demorest.",
      "page_copy": "Experience the epitome of luxury in Demorest with our stunning apartments at Villas at Old 441. These exclusive residences offer designer finishes that elevate everyday living to a new standard. Each apartment combines sophistication with functionality, crafting a comfortable yet stylish environment.\n\nBeyond the exquisite interiors, our community features unrivaled amenities such as a serene beer garden, a fully-equipped fitness center, and a fun-filled playground to suit every lifestyle. At Villas at Old 441, luxury meets convenience, making it the premier choice for those seeking upscale living in Demorest. Embrace a refined living experience tailored just for you.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Designer Finishes",
      "seo_description": "Villas at Old 441 in Demorest offers luxury apartments with designer finishes and superb amenities. Discover upscale living today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "page_item_url": "granite-counter-apartments-north-georgia-villas-at-old-441",
      "search_query": "granite counter apartments in North Georgia",
      "category": "Amenity",
      "h1_title": "Stylish Apartments with Granite Counters",
      "h2_subtitle": "Villas at Old 441 offers exquisite North Georgia living with beautiful granite counter apartments in Demorest.",
      "page_copy": "Looking for granite counter apartments in North Georgia? Discover the Villas at Old 441, where modern aesthetic meets the charm of Demorest living. Our apartments feature upscale granite countertops that enhance both the functionality and elegance of your kitchen, perfect for culinary enthusiasts.\n\nBeyond these premium finishes, our community offers top-tier amenities such as a vibrant beer garden and state-of-the-art fitness center. Families can also enjoy the fresh air at our inviting playground. Relish the stylish lifestyle in one of North Georgia's finest communities at Villas at Old 441. Each detail is designed with your comfort in mind, providing a remarkable living experience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Granite Counter Apartments in North Georgia",
      "seo_description": "Discover granite counter apartments in North Georgia at Villas at Old 441. Sophisticated style meets modern living in Demorest.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-demorest-ga-villas-at-old-441",
      "search_query": "one bedroom apartments Demorest GA",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Demorest, GA",
      "h2_subtitle": "Explore comfort and convenience with our one bedroom apartments in Demorest, GA at Villas at Old 441.",
      "page_copy": "Searching for comfortable one bedroom apartments in Demorest, GA? Villas at Old 441 offers stylish and spacious living options, perfect for singles or couples looking to settle in this charming Georgia town. Each apartment features a chef-inspired kitchen, complete with designer finishes that elevate your living experience.\n\nResidents can enjoy our range of community amenities designed to enhance a balanced lifestyle. From unwinding at the beer garden to building strength in the fitness center, there's something for everyone at our property. Experience the vibrant community and find your cozy new home in our one-bedroom apartments at Villas at Old 441.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Demorest, GA",
      "seo_description": "Discover comfortable living at Villas at Old 441. Our one bedroom apartments in Demorest, GA offer style, convenience, and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-habersham-county-villas-at-old-441",
      "search_query": "two bedroom apartments Habersham County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Habersham County",
      "h2_subtitle": "Find the perfect two bedroom apartments in Habersham County at Villas at Old 441, offering spacious living in Demorest, GA.",
      "page_copy": "Villas at Old 441 invites you to explore our spacious two bedroom apartments in Habersham County. Situated in the picturesque town of Demorest, these apartments blend convenience and luxury with generous living spaces ideal for families or roommates. Enjoy a chef-inspired kitchen with modern designer finishes, perfect for entertaining or everyday cooking.\n\nOur community provides top-notch amenities to enrich every resident's lifestyle. You'll find a tranquil beer garden, a well-equipped fitness center, and a playground for some fun outdoor activities. Experience elevated living in Habersham County at Villas at Old 441, where comfort meets style at every turn.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Habersham County",
      "seo_description": "Explore two bedroom apartments at Villas at Old 441 in Habersham County. Enjoy spacious, stylish living in Demorest, GA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-near-30535-villas-at-old-441",
      "search_query": "three bedroom apartments near 30535",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 30535",
      "h2_subtitle": "Discover the perfect three bedroom apartments near 30535 with Villas at Old 441, offering ample space and modern amenities.",
      "page_copy": "If you're looking for three bedroom apartments near 30535, Villas at Old 441 presents an ideal living solution with ample room and contemporary elegance. Perfect for families or those needing extra space, these apartments feature chef-inspired kitchens that cater to all your culinary needs and designer finishes that add a touch of sophistication.\n\nThe property is thoughtfully equipped with amenities that create a community feel. Relax at our beer garden, maintain a healthy lifestyle in our fully-equipped fitness center, or let the kids explore our engaging playground. Experience the best of Demorest living with our expansive three bedroom options at Villas at Old 441.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 30535",
      "seo_description": "Find spacious three bedroom apartments near 30535 at Villas at Old 441 in Demorest, GA. Perfect for families with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "page_item_url": "apartments-near-piedmont-university-demorest-villas-at-old-441",
      "search_query": "apartments near piedmont university demorest",
      "category": "School",
      "h1_title": "Apartments Near Piedmont University, Demorest",
      "h2_subtitle": "Live close to campus in our apartments near Piedmont University in Demorest, offering convenience and modern living at Villas at Old 441.",
      "page_copy": "Searching for the convenience of living close to campus? Discover our apartments near Piedmont University in Demorest at Villas at Old 441. These well-appointed homes offer a blend of modern luxury and practicality, making them perfect for students, faculty, or staff. Enjoy chef-inspired kitchens with designer finishes, ideal for both quick meals and gourmet cooking.\n\nBeyond the comfort of your apartment, our community features a variety of amenities to enhance your college life. Unwind in the beer garden, stay fit in our state-of-the-art fitness center, or enjoy some downtime at the playground. Experience convenient, stylish living just moments from Piedmont University at Villas at Old 441.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Piedmont University, Demorest",
      "seo_description": "Villas at Old 441 offers modern apartments near Piedmont University in Demorest, combining convenience with stylish amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "page_item_url": "apartment-rentals-close-to-north-georgia-technical-college-habersham-villas-at-old-441",
      "search_query": "apartment rentals close to north georgia technical college habersham county",
      "category": "School",
      "h1_title": "Apartments Close to North Georgia Tech College",
      "h2_subtitle": "Discover ideal apartment rentals close to North Georgia Technical College in Habersham County at Villas at Old 441, offering comfort and proximity.",
      "page_copy": "For those attending or working at North Georgia Technical College, finding the right place to live is essential. Villas at Old 441 offers apartment rentals conveniently close to the college, combining an excellent location with superior living. Enjoy beautiful apartments with chef-inspired kitchens and stylish designer finishes, making everyday life enjoyable.\n\nOur community provides a host of amenities catering to varied lifestyles. Whether you're unwinding at our beer garden, working out in the fitness center, or enjoying family time at the playground, Villas at Old 441 offers the perfect community setting. Discover premium apartment rentals just a short drive from North Georgia Technical College in the heart of Habersham County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to North Georgia Tech College",
      "seo_description": "Find convenient apartment rentals at Villas at Old 441, close to North Georgia Technical College in Habersham County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "page_item_url": "apartments-near-northeast-georgia-medical-center-habersham-villas-at-old-441",
      "search_query": "apartments near Northeast Georgia Medical Center Habersham Demorest",
      "category": "Hospital",
      "h1_title": "Apartments Near Northeast Georgia Medical Center",
      "h2_subtitle": "Explore our apartments near Northeast Georgia Medical Center Habersham in Demorest. Enjoy convenient access and modern living at Villas at Old 441.",
      "page_copy": "Villas at Old 441 in Demorest, GA offers apartment homes near Northeast Georgia Medical Center in Habersham County. The community provides convenient access to nearby medical facilities, local services, and surrounding destinations.\nResidences feature modern kitchen layouts and updated finishes. Community amenities include a fitness center, beer garden, and playground. Villas at Old 441 provides a well-maintained residential community with convenient access to major roadways and nearby destinations.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Northeast Georgia Medical Center",
      "seo_description": "Villas at Old 441 offers modern apartments near Northeast Georgia Medical Center in Demorest, Habersham. ",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "page_item_url": "villas-at-old-441-close-to-hospital-ga",
      "search_query": "Villas at Old 441 close to hospital GA",
      "category": "Hospital",
      "h1_title": "Villas at Old 441 Close to Hospital GA",
      "h2_subtitle": "Discover Villas at Old 441, perfectly situated close to hospitals in GA, offering a blend of comfort and convenience for modern living.",
      "page_copy": "Villas at Old 441 in Demorest, GA offers apartment homes with convenient access to nearby hospitals and medical facilities. The community is located within Habersham County and provides access to local services and major roadways.\nResidences feature modern kitchen layouts and updated finishes. Community amenities include a fitness center, beer garden, and playground. Villas at Old 441 provides a well-maintained residential community in a convenient Demorest location.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Villas at Old 441 Close to Hospital GA",
      "seo_description": "Explore Villas at Old 441, offering easy access to GA hospitals, complete with modern amenities and convenient living options.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "page_item_url": "northeast-georgia-medical-center-habersham-nearby-apartments",
      "search_query": "Northeast Georgia Medical Center Habersham nearby apartments",
      "category": "Hospital",
      "h1_title": "Nearby Apartments to NE Georgia Medical Center",
      "h2_subtitle": "Discover nearby apartments to Northeast Georgia Medical Center Habersham, offering convenience and comfort at Villas at Old 441.",
      "page_copy": "Villas at Old 441 in Demorest, GA offers apartment homes with access to Northeast Georgia Medical Center Habersham and other nearby destinations. The community provides access to local services and major roadways throughout Habersham County.\nResidences feature modern kitchen layouts and updated finishes. Community amenities include a fitness center, beer garden, and playground. Villas at Old 441 is located in Demorest, GA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nearby Apartments to NE Georgia Medical Center",
      "seo_description": "Find nearby apartments to Northeast Georgia Medical Center Habersham at Villas at Old 441, promising convenience and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "page_item_url": "habersham-county-apartments-close-to-hospitals",
      "search_query": "Habersham County apartments close to hospitals",
      "category": "Hospital",
      "h1_title": "Habersham County Apartments Near Hospitals",
      "h2_subtitle": "Explore Habersham County apartments close to hospitals. Villas at Old 441 offers the perfect blend of convenience and modern amenities.",
      "page_copy": "Villas at Old 441 in Demorest, GA offers apartment homes with access to nearby hospitals and healthcare facilities in Habersham County. The community provides access to local services and major roadways.\nResidences feature modern kitchen layouts and updated finishes. Community amenities include a fitness center, beer garden, and playground. Villas at Old 441 provides a well-maintained residential community in Demorest, GA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Habersham County Apartments Near Hospitals",
      "seo_description": "Discover Villas at Old 441, Habersham County apartments close to hospitals, combining modern comforts and convenient access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "page_item_url": "30535-apartments-near-hospitals",
      "search_query": "30535 apartments near hospitals",
      "category": "Hospital",
      "h1_title": "30535 Apartments Near Hospitals",
      "h2_subtitle": "Find 30535 apartments near hospitals at Villas at Old 441. Perfectly located in Demorest, offering prime access and top-notch amenities.",
      "page_copy": "Looking for 30535 apartments near hospitals? Villas at Old 441 in Demorest is your answer. Positioned strategically within zip code 30535, this community offers convenient access to nearby hospitals, making it an excellent choice for healthcare professionals and residents needing easy access to medical facilities. \n\nVillas at Old 441 features luxurious apartment interiors with chef-inspired kitchens and designer finishes. Beyond the doors of your apartment, enjoy community amenities like a state-of-the-art fitness center, a relaxing beer garden, and a family-friendly playground. The blend of accessible location and modern living conveniences makes Villas at Old 441 an outstanding option for those seeking hassle-free commutes and a vibrant community atmosphere.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "30535 Apartments Near Hospitals",
      "seo_description": "Discover Villas at Old 441, premium 30535 apartments near hospitals, offering modern amenities and convenient medical access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "page_item_url": "apartments-near-cornelia-city-park-ga",
      "search_query": "apartments near Cornelia City Park GA",
      "category": "Park",
      "h1_title": "Apartments Near Cornelia City Park, GA",
      "h2_subtitle": "Discover apartments near Cornelia City Park, GA at Villas at Old 441. Experience modern living with easy park access.",
      "page_copy": "Villas at Old 441 in Demorest, GA offers apartment homes with convenient access to Cornelia City Park and surrounding outdoor areas. The community provides access to local services and major roadways.\nResidences feature modern kitchen layouts and updated finishes. Community amenities include a fitness center, beer garden, and playground. Villas at Old 441 is located in Demorest, GA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Cornelia City Park, GA",
      "seo_description": "Explore Villas at Old 441, close to Cornelia City Park, GA, offering stylish living and unmatched community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "page_item_url": "apartments-close-to-pitts-park-demorest",
      "search_query": "apartments close to Pitts Park Demorest",
      "category": "Park",
      "h1_title": "Apartments Close to Pitts Park, Demorest",
      "h2_subtitle": "Find apartments close to Pitts Park in Demorest at Villas at Old 441. Experience the ideal blend of nature and modern living.",
      "page_copy": "Searching for apartments close to Pitts Park in Demorest? Villas at Old 441 places you right next to this charming outdoor haven, making it easy to enjoy leisurely strolls or active afternoons in the park's scenic surroundings. Our strategic location in Demorest offers the perfect balance of natural beauty and modern conveniences.\n\nThe Villas at Old 441 boasts lovely apartments featuring chef-inspired kitchens and tasteful designer finishes. Our community is designed with your lifestyle in mind, offering amenities such as a fitness center, a beer garden, and a playground. When you choose to live here, you're choosing a home that's as close to the serene atmosphere of Pitts Park as it is to essential comforts and luxuries.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Pitts Park, Demorest",
      "seo_description": "Live near Pitts Park in Demorest at Villas at Old 441, combining scenic park access with modern apartment amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "page_item_url": "properties-around-buck-shoals-wma",
      "search_query": "properties around Buck Shoals Wildlife Management Area",
      "category": "Park",
      "h1_title": "Properties Around Buck Shoals WMA",
      "h2_subtitle": "Discover properties around Buck Shoals Wildlife Management Area, including Villas at Old 441. Enjoy nature's proximity and modern comforts.",
      "page_copy": "Villas at Old 441 in Demorest, GA offers apartment homes with access to Buck Shoals Wildlife Management Area and surrounding outdoor destinations. The community provides access to local services and major roadways throughout Habersham County.\nResidences feature modern kitchen layouts and updated finishes. Community amenities include a fitness center, beer garden, and playground. Villas at Old 441 is located in Demorest, GA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Properties Around Buck Shoals WMA",
      "seo_description": "Explore Villas at Old 441, close to Buck Shoals Wildlife Management Area, for a blend of nature access and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "page_item_url": "rentals-by-demorest-spring-park-30535",
      "search_query": "rentals by Demorest Spring Park 30535",
      "category": "Park",
      "h1_title": "Rentals by Demorest Spring Park 30535",
      "h2_subtitle": "Explore rentals by Demorest Spring Park, 30535 at Villas at Old 441. Enjoy park proximity and luxury living.",
      "page_copy": "Villas at Old 441 in Demorest, GA offers apartment homes with convenient access to Demorest Spring Park in the 30535 zip code. The community provides access to local services and nearby destinations.\nResidences feature modern kitchen layouts and updated finishes. Community amenities include a fitness center, beer garden, and playground. Villas at Old 441 provides a well-maintained residential community in Demorest, GA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals by Demorest Spring Park 30535",
      "seo_description": "Discover Villas at Old 441, offering rentals near Demorest Spring Park, 30535, combining park accessibility with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167445",
      "source": "custom",
      "page_item_url": "villas-near-habersham-county-park-rec",
      "search_query": "Villas near Habersham County Park & Rec",
      "category": "Park",
      "h1_title": "Villas Near Habersham County Park & Rec",
      "h2_subtitle": "Villas at Old 441 offers villas near Habersham County Park & Rec. Experience lifestyle amenities with nature nearby.",
      "page_copy": "Villas at Old 441 in Demorest, GA offers apartment homes with convenient access to Habersham County Park & Recreation and surrounding outdoor areas. The community provides access to local services and major roadways.\nResidences feature modern kitchen layouts and updated finishes. Community amenities include a fitness center, beer garden, and playground. Villas at Old 441 is located in Demorest, GA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Villas Near Habersham County Park & Rec",
      "seo_description": "Discover Villas at Old 441, located near Habersham County Park & Rec, offering easy access to outdoor fun and luxury amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6082"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11671070259"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-5L5XR8KQ"
    },
    {
      "ID": "custom_entrata_chatbot",
      "type": "STRING",
      "value": "<script>Object.assign(window, {websiteToken: 'Q7Uc6Hffji8Z8fs6wCiU7pHE', siteConfig: {clt_i: \"102052\", property_id: \"100160113\"}});</script><script src=\"https://commoncf.entrata.com/javascript/comms/init.js?ver=1671933\"></script>"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "86e26a11f0cc4afa"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "b484f0cc984e11eebcb40e136090bd39"
    },
    {
      "ID": "custom_call_rail_company_id",
      "type": "STRING",
      "value": "161214513"
    },
    {
      "ID": "custom_call_rail_account_hash",
      "type": "STRING",
      "value": "22cba132aba88e328866"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "3f4d2b72-e689-11f0-b8e3-9b7fb13a3d0c"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "ca6e7a0c-0871-4502-b699-60d5f5cfcb57"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/ca6e7a0c-0871-4502-b699-60d5f5cfcb57/3f4d2b72-e689-11f0-b8e3-9b7fb13a3d0c/tour"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImMreTU5NUxyWWNFT2dTZUYzOUs5Wnc9PSIsInZhbHVlIjoiclpnSEpSdG5FalMyUE1HZmpKNmdJQT09IiwibWFjIjoiMjBiMWY4NGE2NzNkNjMwYjdiODE3YzJkZWM0ODZjM2U0M2U1NjJiM2EwZTg2ODk0NTkwNTBhNTIxNDJlMzlhYiJ9"
    }
  ],
  "custom_qb_id": "6082",
  "custom_repli_id": "11671070259",
  "custom_google_gtm_id": "GTM-5L5XR8KQ",
  "custom_entrata_chatbot": "<script>Object.assign(window, {websiteToken: 'Q7Uc6Hffji8Z8fs6wCiU7pHE', siteConfig: {clt_i: \"102052\", property_id: \"100160113\"}});</script><script src=\"https://commoncf.entrata.com/javascript/comms/init.js?ver=1671933\"></script>",
  "custom_knock_community_id": "86e26a11f0cc4afa",
  "custom_knock_company_token": "b484f0cc984e11eebcb40e136090bd39",
  "custom_call_rail_company_id": "161214513",
  "custom_call_rail_account_hash": "22cba132aba88e328866",
  "custom_eliseai_building_token": "3f4d2b72-e689-11f0-b8e3-9b7fb13a3d0c",
  "custom_eliseai_organization_id": "ca6e7a0c-0871-4502-b699-60d5f5cfcb57",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/ca6e7a0c-0871-4502-b699-60d5f5cfcb57/3f4d2b72-e689-11f0-b8e3-9b7fb13a3d0c/tour",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImMreTU5NUxyWWNFT2dTZUYzOUs5Wnc9PSIsInZhbHVlIjoiclpnSEpSdG5FalMyUE1HZmpKNmdJQT09IiwibWFjIjoiMjBiMWY4NGE2NzNkNjMwYjdiODE3YzJkZWM0ODZjM2U0M2U1NjJiM2EwZTg2ODk0NTkwNTBhNTIxNDJlMzlhYiJ9",
  "custom_audioeye_site_id": "f448a90a-7ec2-4e75-9ed5-891d95f4250b",
  "custom_audioeye_site_hash": "1904a1b9f11b570f63f867c1d81dea5a"
};

export const generatedAt = '2026-10-01T17:22:15.292Z';
